<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>会员档案</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-button size="mini" plain @click="showOrderDialog" :disabled="isMain"
                 v-if="authorities.includes('customer.card.order.new')">新建消费单</el-button>
      <el-button size="mini" plain @click="showRechargeDialog" :disabled="isMain"
                 v-if="authorities.includes('customer.card.recharge')">会员充值</el-button>
      <el-button size="mini" plain @click="showCkDialog">购买次卡</el-button>
      <el-button size="mini" plain @click="showReturnPremiumDialog"
                 v-if="authorities.includes('customer.card.recharge.return')" :disabled="isMain">充值退费</el-button>
      <el-button size="mini" plain v-if="authorities.includes('customer.card.img')">图片上传</el-button>
      <el-button size="mini" plain @click="showCustomerCommentDialog"
                 v-if="authorities.includes('customer.card.comment')">添加备注</el-button>
      <el-button size="mini" @click="routerOrder" plain>去消费单</el-button>
    </div>

    <div class="between">
      <div class="left_con">
        <div class="left_inner_con">
          <el-card class="box-card">
            <div>
              <span class="spanLabel">姓名：</span>
              <span style="font-size: 20px;color: #2E64FE">{{customer.customerName}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">联系电话：</span>
              <span class="spanLabel">{{customer.phone}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">会员类别：</span>
              <span class="spanLabel">{{customerTypeArr[customer.customerType]}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">性别：</span>
              <span class="spanLabel">{{dangerArr[customer.gender]}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">生日：</span>
              <span v-if="customer.birthday !== null" class="spanLabel">{{customer.birthday.substring(0,10)}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">年龄：</span>
              <span class="spanLabel">{{customer.age}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">来源：</span>
              <span class="spanLabel">{{sourceArr[customer.source]}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">职业：</span>
              <span class="spanLabel">{{professionArr[customer.profession]}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">刀具：</span>
              <span class="spanLabel">{{customer.knife}}</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">总余额：</span>
              <span class="spanLabel">{{customer.totalBalance}}元</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">总次数：</span>
              <span class="spanLabel">{{customer.cardNum}}次</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">总赠送额：</span>
              <span class="spanLabel">{{customer.totalGiveBalance}}元</span>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">档案号：</span>
              <span class="spanLabel">{{customer.customerNo}}</span>
            </div>
            <!-- <div style="margin-top: 5px;">
              <span class="spanLabel">足部筛查：</span>
              <template >
                <span class="spanLabel" style="margin-left: 5px;" v-for="(item,index) in customer.footDiseases" :key="index">
                  {{item.diseaseName}}
                </span>
              </template>
            </div>
            <div style="margin-top: 5px;">
              <span class="spanLabel">既往病史：</span>
              <template >
                <span class="spanLabel" style="margin-left: 5px;" v-for="(item,index) in customer.pastDiseases" :key="index">
                  {{item.diseaseName}}
                </span>
              </template>
            </div> -->
            <div >
              <span class="spanLabel">是否主卡：</span>
              <span class="spanLabel" style="margin-left: 5px;">
                {{isMainText}}
              </span>
            </div>
            <div style="margin-top: 5px;" v-if="customer.main === 1">
              <span class="spanLabel">关联副卡：</span>
              <template >
                <span class="spanLabel" style="margin-left: 5px;" v-for="(item,index) in customer.relevanceCustomers" :key="index">
                  {{item.customerName}}
                </span>
              </template>
            </div>
            <div style="margin-top: 5px;" v-if="customer.main === 2">
              <span class="spanLabel">关联主卡：</span>
              <template >
                <el-link
                         @click.prevent="toDetail(customer.byRelevanceCustomer.id)" >{{customer.byRelevanceCustomer.customerName}}</el-link>
              </template>
            </div>
            <div style="margin-top: 5px;">
              <template >
                <el-link
                  @click="moreCustomer">更多档案信息</el-link>
              </template>
            </div>
<!--            <div style="margin-top: 5px;">-->
<!--              <span class="spanLabel">康复对比图：</span>-->
<!--              <span class="spanLabel">查看</span>-->
<!--            </div>-->
          </el-card>
        </div>
      </div>

      <!-- 右边table列表部分 -->
      <div class="table_container" style="margin: 10px 0">
        <div style="background-color: #F2F6FC;height: 25px;border: 1px solid rgb(222,222,222);">
          <span style="margin-left: 10px; color: #3a8ee6; font-size: x-small">该会员消费合计：{{xfhj}}元</span>
          <span style="margin-left: 60px; color: #3a8ee6; font-size: x-small">该会员充值合计：{{czhj}}元</span>
          <span style="margin-left: 60px; color: #3a8ee6; font-size: x-small">该会员退费合计：{{tfhj}}元</span>
          <span style="margin-left: 60px; color: #3a8ee6; font-size: x-small">该会员优惠金额合计：{{yhhj}}元</span>
        </div>
        <el-tabs type="border-card">
          <el-tab-pane label="消费单">
            <el-table :height="tableHeight" :data="saleList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="orderStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                fixed="fixed"
                label="操作" width="140"
              >
                <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-evenly">
                    <el-link type="primary" icon="iconfont icon-xiangqing" @click="showOrderDetailDialog(scope.row)"></el-link>
                    <el-link type="primary" icon="el-icon-edit"
                             :disabled="scope.row.isSubmit == 1 || scope.row.orderOrgId != currentOrgId || scope.row.state === 4"
                             v-if="authorities.includes('customer.card.order.update.yizhi')"
                             @click="showUpdateOrderDialog(scope.row)"></el-link>
                    <el-link type="primary" icon="el-icon-edit"
                             :disabled="nowDate != scope.row.orderDateStr || scope.row.orderOrgId != currentOrgId
                             || scope.row.state === 4"
                             v-if="authorities.includes('customer.card.order.update.today')"
                             @click="showUpdateOrderDialog(scope.row)"></el-link>

                    <div v-if="authorities.includes('customer.card.order.cancel.yizhi')">
                      <el-link type="danger" :disabled="scope.row.state === 4 || scope.row.state === 2 || scope.row.state === 3"
                               icon="iconfont icon-zuofei" @click="isCancelOrder(scope.row)"></el-link>
                    </div>
                    <div v-if="authorities.includes('customer.card.order.cancel.dangyue')">
                      <el-link type="danger" :disabled="nowDate != scope.row.orderDateStr || scope.row.state === 4
                              || scope.row.state === 2 || scope.row.state === 3"
                               icon="iconfont icon-zuofei" @click="isCancelOrder(scope.row)"></el-link>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderDate"
                label="消费日期" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="state"
                :formatter="stateFormatter"
                label="状态" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="customerName"
                label="会员名称" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderReceivable"
                label="应收金额" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderDiscounts"
                label="优惠金额" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="moLing"
                label="抹零金额" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="couZheng"
                label="凑整金额" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                label="欠款金额" >
                <template slot-scope="scope">
                  <span v-if="scope.row.isHk === 1" style="color: #0CB618">{{scope.row.arrearageMoney}}</span>
                  <span v-if="scope.row.isHk === 2" style="color: #EA1B28">{{scope.row.arrearageMoney}}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderReceived"
                label="实收金额" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="refundMoney"
                label="退费金额" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="payType"
                label="支付方式" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="viceName"
                label="下单人" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderOrgName"
                label="消费门店" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderNo"
                label="消费单号" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="modifierName"
                label="修改人" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="isSubmit"
                label="连通用友"
                :formatter="submitFormatter"
                width="150">
              </el-table-column>
              <el-table-column
                align="center"
                label="备注说明"
                width="250">
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                    <p>{{ scope.row.comment }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="mini">{{ scope.row.comment }}</el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="欠款单">
            <el-table :height="tableHeight" :data="arrOrderList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333', fontWeight:700}"
                      :row-style="{height: '0'}"
            >
              <el-table-column
                align="center"
                width="80px"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-link type="primary"  icon="iconfont icon-huankuan" title="还款" :disabled="scope.row.state === 2"
                           @click="showHkDialog(scope.row)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="customerName"
                label="会员名称" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="arrearageDate"
                label="欠款日期" width="170">
              </el-table-column>
              <el-table-column
                align="center"
                prop="state"
                :formatter="arrOrderStateFormatter"
                label="状态" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="arrearageMoney"
                label="欠款金额" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="moLing"
                label="抹零金额" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="sjHk"
                label="实际还款" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="payType"
                label="支付方式" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="shopName"
                label="消费门店" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="originalOrderNo"
                label="原消费单号" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="originalOrderId"
                label="原消费单id" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="创建时间"
                width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="modifyTime"
                label="最后操作时间" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="modifyName"
                label="最后操作人" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="isSubmit"
                label="连通用友"
                :formatter="submitFormatter">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充值记录">
            <el-table :height="tableHeight" :data="rechargeList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="rechargeStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                prop="userName"
                fixed="fixed"
                label="操作" width="100">
                <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-evenly">
                    <el-link type="primary" icon="iconfont icon-bianji"
                             v-if="authorities.includes('customer.card.recharge.update.yizhi')"
                             @click="showModifyRechargeDialog(scope.row)"></el-link>
                    <el-link type="primary" icon="iconfont icon-bianji"
                             :disabled="nowDate != scope.row.rechargeDate"
                             v-if="authorities.includes('customer.card.recharge.update.today')"
                             @click="showModifyRechargeDialog(scope.row)"></el-link>
                    <el-link type="danger" :disabled="scope.row.state === 2 || scope.row.isRefund === 1"
                               v-if="authorities.includes('customer.card.recharge.cancel.yizhi')"
                               icon="iconfont icon-zuofei" @click="cancelRecharge(scope.row)"></el-link>
                    <el-link type="danger" :disabled="scope.row.state === 2 || nowDate != scope.row.rechargeDate
                              || scope.row.isRefund === 1"
                             v-if="authorities.includes('customer.card.recharge.cancel.today')"
                             icon="iconfont icon-zuofei" @click="cancelRecharge(scope.row)"></el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="rechargeDate"
                label="充值日期" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="state"
                :formatter="rechargeStateFormatter"
                label="状态" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="customerName"
                label="会员名称" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="money"
                label="充值金额" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="payType"
                label="支付方式" width="250">
              </el-table-column>
              <el-table-column
                align="center"
                prop="viceName"
                label="充值人" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="充值门店" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="创建日期" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                label="备注说明"
                width="250">
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                    <p>{{ scope.row.comment }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="mini">{{ scope.row.comment }}</el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage1"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal1">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="次卡记录">
            <el-table :height="tableHeight" :data="customerBuyCkList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="cikaStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                fixed="fixed"
                label="操作" width="100">
                <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-evenly">
                    <el-link type="primary" icon="iconfont icon-bianji"
                             :disabled="scope.row.state == 4"
                             @click="showModifyCustomerCk(scope.row)"></el-link>
                    <el-link type="primary" icon="iconfont icon-zuofei"
                             :disabled="scope.row.buyDate != today || scope.row.syNum != scope.row.cardNum
                                      || scope.row.state == 4"
                             @click="cancelCustomerCk(scope.row)"></el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="customerName"
                label="会员姓名" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="cardTypeName"
                label="次卡名称" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="cardNum"
                label="卡片次数" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="syNum"
                label="剩余次数" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="money"
                label="购买价格" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="state"
                :formatter="cardStateFormatter"
                label="状态" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="useTypeName"
                label="用途" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="shopName"
                label="所属门店" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="购买日期" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="validDate"
                label="有效期至" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="modifyValidDate"
                label="修改前有效期" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="modifyTime"
                label="修改日期" width="180">
              </el-table-column>

            </el-table>
<!--            <div style="margin-top: 3px;">-->
<!--              <el-pagination-->
<!--                @size-change="handleSizeChange1"-->
<!--                @current-change="handleCurrentChange1"-->
<!--                :current-page="currentPage1"-->
<!--                :page-sizes="[10, 20, 30, 50]"-->
<!--                :page-size="pageSize1"-->
<!--                layout="total, sizes, prev, pager, next, jumper"-->
<!--                :total="pageTotal1">-->
<!--              </el-pagination>-->
<!--            </div>-->
          </el-tab-pane>
          <el-tab-pane label="多卡别">
            <el-table :height="tableHeight" :data="customerCardList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                prop="userName"
                fixed="fixed"
                label="操作">
                <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-evenly">
                    <el-link type="primary" icon="iconfont icon-bianji"
                             :disabled="scope.row.cardType == 3"
                             @click="showModifyCustomerCard(scope.row)"></el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="cardTypeName"
                label="卡别">
              </el-table-column>
              <el-table-column
                align="center"
                prop="cardLevel"
                :formatter="cardLevelFormatter"
                label="会员等级">
              </el-table-column>
              <el-table-column
                align="center"
                prop="balance"
                label="余额" width="80">
              </el-table-column>
              <el-table-column
                align="center"
                prop="giveBalance"
                label="赠额" width="80">
              </el-table-column>
              <el-table-column
                align="center"
                prop="shopName"
                label="所属门店" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="useTypeName"
                label="适用项目">
              </el-table-column>
              <el-table-column
                align="center"
                prop="state"
                :formatter="cardStateFormatter"
                label="状态" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="validDate"
                label="有效期" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="办理时间"
                width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="createName"
                label="操作人"
                width="100">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="cardSizeChange"
                @current-change="cardCurrentChange"
                :current-page="cardCurrentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="cardPageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="cardPageTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充值退费记录">
            <el-table :height="tableHeight" :data="returnPremiumList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="rechargeStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                fixed="fixed"
                label="操作" width="100">
                <template slot-scope="scope">
                  <el-link type="danger" :disabled="scope.row.state === 2"
                           v-if="authorities.includes('customer.card.recharge.return.cancel')"
                           icon="iconfont icon-zuofei" @click="cancelReturnPremium(scope.row)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="退费日期"
                align="center"
                width="180">
              </el-table-column>
              <el-table-column
                prop="state"
                label="状态"
                align="center"
                :formatter="returnPremiumStateFormatter"
                width="100">
              </el-table-column>
              <el-table-column
                prop="customerName"
                label="会员姓名"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="money"
                label="退费金额"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="refundDiscounts"
                label="退还优惠金额"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="orgName"
                label="退费门店"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="viceName"
                label="退费人"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="serverName"
                label="服务人员"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="serverName"
                label="备注"
                align="center"
                width="150">
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                    <p>{{ scope.row.comment }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="mini">{{ scope.row.comment }}</el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange5"
                @current-change="handleCurrentChange5"
                :current-page="currentPage5"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal5">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="物品存放">
            <el-table :height="tableHeight" :data="storeProductList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="rechargeStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                fixed="fixed"
                label="操作" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" v-if="authorities.includes('customer.card.store.tiqu')"
                             icon="iconfont icon-wupinquchu-05"
                             @click="showGetProductDialog(scope.row)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="存放日期" width="180">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="存放门店" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="productName"
                label="产品名称"
                width="250">
              </el-table-column>
              <el-table-column
                align="center"
                prop="storeNum"
                label="剩余寄存数量" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="getNum"
                label="共提取数量" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="serverName"
                label="服务人员" width="100">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderNo"
                label="订单编号">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange3"
                @current-change="handleCurrentChange3"
                :current-page="currentPage3"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize3"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal3">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员备注">
            <el-table :height="tableHeight" :data="customerComments" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="rechargeStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                prop="orgName"
                width="200"
                label="所属门店">
              </el-table-column>
              <el-table-column
                align="center"
                prop="commentDate"
                label="备注日期" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="comment"
                label="备注内容">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange6"
                @current-change="handleCurrentChange6"
                :current-page="currentPage6"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize6"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal6">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="主副卡绑定记录">
            <el-table :height="tableHeight" :data="bindCustomerRecord" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="rechargeStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                prop="createTime"
                label="绑定/解绑日期" width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="type"
                :formatter="bindFormatter"
                label="类别" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="comment"
                label="内容">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange7"
                @current-change="handleCurrentChange7"
                :current-page="currentPage7"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize7"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal7">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="历史消费单">
            <el-table :height="tableHeight" :data="oldOrderData" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :cell-style="rechargeStateColor"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                fixed="fixed"
                label="操作" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" icon="iconfont icon-xiangqing"
                        @click="showOldOrderDetailDialog(scope.row)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderType"
                :formatter="oldOrderStateFormatter"
                label="订单状态" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderDate"
                label="订单日期" width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderCode"
                label="订单编号"
                width="150">
              </el-table-column>
              <el-table-column
                align="center"
                prop="customerName"
                label="会员名称"
                width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="paidAmount"
                label="消费金额"
                width="200">
              </el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="消费门店">
              </el-table-column>
              <el-table-column
                align="center"
                prop="id"
                label="消费单ID">
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange8"
                @current-change="handleCurrentChange8"
                :current-page="currentPage8"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize8"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal8">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 创建消费单窗口-->
    <el-dialog
      title="新建消费单"
      :visible.sync="orderDialogVisible"
      width="70%"
      @close="closeOrderDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex; align-items: center;justify-content: space-between;width: 100%;">
          <div>
            <span>会员姓名：</span>
            <el-input v-model="customer.customerName" readonly placeholder="请输入内容" size="mini" style="width: 50%;"></el-input>
          </div>
          <div>
            <span >消费人次：</span>
            <el-input v-model="order.peoples" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" style="width: 40%;"></el-input>
          </div>
          <div style="width: 40%;">
            <span >异地消费：</span>
            <el-radio-group v-model="order.isLocal">
              <el-radio :label="1">异地</el-radio>
              <el-radio :label="2">本地</el-radio>
            </el-radio-group>
          </div>
          <div>
            <el-checkbox v-model="order.isArrearage" @change="arrearageMethod">欠款单</el-checkbox>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>卡别信息：</span>
        <el-button size="mini" :disabled="customer.customerType > 1" @click="showCustomerCardDialog">选择卡别</el-button>
      </div>
      <el-card>
        <div v-if="selectedCustomerCard !== '' ">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="selectedCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="selectedCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="selectedCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="selectedCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="selectedCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="selectedCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="selectedCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div v-if="selectedCustomerCard.cardType === 2">
            <div style="width: 50%;margin-top: 10px" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="selectedCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="selectedCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 20%">可用次数：</span>
              <el-input v-model="selectedCustomerCard.cardNum" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="selectedCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>消费明细：</span>
        <el-button size="mini" plain @click="showConsumptionDialog">添加明细</el-button>
      </div>
      <el-card>
        <el-table :data="consumptionShowList" fit border stripe="stripe" width="100%"
                  max-height="300"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}" :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteConsumptionShowList(scope.$index, consumptionShowList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="dia"
            label="直径"
          >
            <template slot-scope="scope">
              <el-input :disabled="scope.row.isShowDia !== 1" v-model="scope.row.dia"
                        size="mini" @change="changeZj" ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="数量/次数" width="170">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.num"
                               size="mini" :precision="0"
                               @change="changeZj" :min="1" :max="1000" label="描述文字"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" >
          </el-table-column>
          <el-table-column
            align="center"
            label="会员价格">
            <template slot-scope="scope">
              <div v-if="scope.row.type === 1">
                <div v-if="customer.customerType == 1">
                  <!-- 会员余额>0可享受折扣 -->
<!--                  <div v-if="selectedCustomerCard === ''">-->
<!--                    {{scope.row.price}}-->
<!--                  </div>-->
                  <div v-if="selectedCustomerCard.balance > 0">
                    <div v-if="selectedCustomerCard.cardLevel === 0">
                      {{scope.row.price}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 1">
                      {{scope.row.priceDiamond}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 2">
                      {{scope.row.pricePlatinum}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 3">
                      {{scope.row.priceGold}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 4">
                      {{scope.row.priceBronze}}
                    </div>
                  </div>
<!--                  <div v-if="selectedCustomerCard.balance === 0 || selectedCustomerCard.cardLevel === 0">-->
<!--                    {{scope.row.price}}-->
<!--                  </div>-->
                </div>
                <div v-if="customer.customerType > 1">
                  {{scope.row.price}}
                </div>
              </div>
              <div v-if="scope.row.type === 2">
                <div v-if="customer.customerType == 1">
                  <!-- 会员余额>0可享受折扣 -->
                  <div v-if="selectedCustomerCard.balance > 0 && selectedCustomerCard.cardLevel > 0">
                    {{ (scope.row.price * (selectedCustomerCard.productDiscount/100)).toFixed(2)}}
                  </div>
                  <div v-if="selectedCustomerCard.balance === 0 || selectedCustomerCard.cardLevel === 0">
                    {{scope.row.price.toFixed(2)}}
                  </div>
<!--                  <div v-if="selectedCustomerCard === ''">-->
<!--                    {{scope.row.price.toFixed(2)}}-->
<!--                  </div>-->
                </div>
                <div v-if="customer.customerType > 1">
                  {{scope.row.price.toFixed(2)}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="金额小计">
            <template slot-scope="scope">
              <div v-if="scope.row.isShowDia === 1">
                {{ (scope.row.price * scope.row.num * scope.row.dia).toFixed(2)}}
              </div>
              <div v-if="scope.row.isShowDia !== 1">
                <div v-if="scope.row.type === 1">
                  <div v-if="customer.customerType == 1">
<!--                    <div v-if="selectedCustomerCard === ''">-->
<!--                      {{ (scope.row.price * scope.row.num).toFixed(2)}}-->
<!--                    </div>-->
                    <!-- 会员余额>0可享受折扣 -->
                    <div v-if="selectedCustomerCard.balance > 0">
                      <div v-if="selectedCustomerCard.cardLevel === 1">
                        {{ (scope.row.priceDiamond * scope.row.num).toFixed(2)}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 2">
                        {{ (scope.row.pricePlatinum * scope.row.num).toFixed(2)}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 3">
                        {{ (scope.row.priceGold * scope.row.num).toFixed(2)}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 4">
                        {{ (scope.row.priceBronze * scope.row.num).toFixed(2)}}
                      </div>
                    </div>
                    <div v-if="selectedCustomerCard.balance === 0 || selectedCustomerCard.cardLevel === 0">
                      {{ (scope.row.price * scope.row.num).toFixed(2)}}
                    </div>
                  </div>
                  <div v-if="customer.customerType > 1">
                    {{ (scope.row.price * scope.row.num).toFixed(2)}}
                  </div>
                </div>
                <div v-if="scope.row.type === 2">
                  <div v-if="customer.customerType == 1">
                    <!-- 会员余额>0可享受折扣 -->
                    <div v-if="selectedCustomerCard.balance > 0 && selectedCustomerCard.cardLevel > 0">
                      {{ (scope.row.price * (selectedCustomerCard.productDiscount/100) * scope.row.num).toFixed(2)}}
                    </div>
                    <div v-if="selectedCustomerCard.balance === 0 || selectedCustomerCard.cardLevel === 0">
                      {{ (scope.row.price * scope.row.num).toFixed(2)}}
                    </div>
<!--                    <div v-if="selectedCustomerCard === ''">-->
<!--                      {{ (scope.row.price * scope.row.num).toFixed(2)}}-->
<!--                    </div>-->
                  </div>
                  <div v-if="customer.customerType > 1">
                    {{ (scope.row.price * scope.row.num).toFixed(2)}}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}" :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机" >
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例" >
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>金额信息：</span>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;align-items: start">
          <div>
            <span>应收金额：</span>
            <el-input v-model="order.receivable" readonly size="mini" style="width: 60%;"></el-input>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">会员优惠：</span>
            <el-input v-model="order.orderDiscounts" readonly size="mini" style="width: 60%;"></el-input>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="order.moLing"  :disabled="isMolingSet" @change="setMoLing"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      placeholder="请输入内容" size="mini" style="width: 60%;"></el-input>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="order.couZheng"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      :disabled="isHyCouZhengSet"
                      @change="setHyOrderCouZheng"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div v-if="order.isArrearage === true">
            <span style="width: 10%;margin-left: 5px;"> 欠款金额：</span>
            <el-input v-model="order.arrearageMoney" onkeyup="value=value.replace(/[^\d.]/g,'')"
                      placeholder="请输入内容" size="mini" style="width: 60%;"
                      @change="setArrearageMoney"
            />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">实收金额：</span>
            <el-input v-model="order.received" readonly size="mini" style="width: 60%;"></el-input>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>优惠券信息：</span>
        <span style="color: #8c939d; font-size: 12px">您有{{ticketCount}}张优惠券可用,每个消费单最多只能使用一张优惠券</span>
        <el-button size="mini"
                   :disabled="consumptionShowList.length === 0 || selectedCustomerCard.cardType == 3"
                   @click="showCustomerTicketDialog">选择优惠券</el-button>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >优惠券类别：</span>
            <el-input v-model="selectedCustomerTicket.ticketTypeName" readonly size="mini" style="width: 60%;"/>
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 1 || selectedCustomerTicket.ticketType === 4 ||
                  selectedCustomerTicket.ticketType === 6" >
            <span style="width: 10%;margin-left: 5px;">面额：</span>
            <el-input v-model="selectedCustomerTicket.money" readonly  placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 3">
            <span style="width: 10%;margin-left: 5px;">满额：</span>
            <el-input v-model="selectedCustomerTicket.fullMoney" readonly size="mini" style="width: 60%;" />
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 3">
            <span style="width: 10%;margin-left: 5px;">减额：</span>
            <el-input v-model="selectedCustomerTicket.subMoney" readonly size="mini" style="width: 60%;" />
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 2 || selectedCustomerTicket.ticketType === 5">
            <span style="width: 10%;margin-left: 5px;"> 折扣率：</span>
            <el-input v-model="selectedCustomerTicket.rate" size="mini" style="width: 60%;" />
          </div>
          <div v-if="selectedCustomerTicket.ticketType > 3">
            <span style="width: 10%;margin-left: 5px;"> 产品和服务：</span>
            <el-input v-model="selectedCustomerTicket.consumptionName" readonly  size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 有效期：</span>
            <el-input v-model="selectedCustomerTicket.validDate" readonly  size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money" :readonly="item.payEnName === 'zengsonghuiyuan' || item.payEnName === 'huiyuan'
                      || item.payEnName == 'douyintuangou' || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'kuaishoutuangou'"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      @change="changeOrderPayMoney"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>备注说明：</span>
      </div>
      <el-card>
        <el-input v-model="order.comment" type="textarea" placeholder="请输入内容" size="mini"/>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeOrderDialog">取 消</el-button>
        <el-button size="mini" @click="createOrder" :disabled="orderIsSubmit == 1">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择服务人员 -->
    <el-drawer
      title="服务人员列表"
      size="450px"
      :visible.sync="serverDialogVisible"
      :before-close="closeServerDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="serverList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"

                @selection-change="serverSelectChange">
        <el-table-column
          align="center"
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="userName"
          label="服务人员姓名">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机">
        </el-table-column>
      </el-table>
    </el-drawer>

    <!-- 显示服务和产品-->
    <el-drawer
      title="添加消费项目"
      size="60%"
      :visible.sync="productDrawer"
      :before-close="closeConsumptionDialog"
      >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <el-card>
              <el-tree
                :data="consumptionTypeList"
                :props="consumptionTypeProps"
                @node-click="consumptionTypeHandleNodeClick"
                :highlight-current="true"
                node-key="id"
                :filter-node-method="consumptionTypeFilterNode"
                default-expand-all
                ref="serviceTree"
              >
              </el-tree>
            </el-card>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-card class="box-card">
            <el-table height="550px" :data="consumptionList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}" >
              <el-table-column
                align="center"
                prop="userName"
                fixed="fixed"
                label="操作" width="160">
                <template slot-scope="scope">
                  <!-- 储值会员 -->
                  <div v-if="customer.customerType == 1">
<!--                    <div v-if="selectedCustomerCard === ''">-->
<!--                      <el-input-number v-model="scope.row.num"-->
<!--                                       size="mini" :precision="0"-->
<!--                                       @change="orderNumHandleChange(scope.row)" :min="0" :max="1000" ></el-input-number>-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                      <el-input-number v-model="scope.row.num"-->
<!--                                       size="mini" :precision="0"-->
<!--                                       v-if="selectedCustomerCard.balance === 0 && scope.row.consumptionParentTypeName !== '次卡'"-->
<!--                                       @change="orderNumHandleChange(scope.row)" :min="0" :max="1000" ></el-input-number>-->
                      <el-input-number v-model="scope.row.num" size="mini" :precision="0"
                                       v-if="selectedCustomerCard.balance > 0 && scope.row.consumptionParentTypeName !== '次卡'"
                                       :disabled="scope.row.consumptionTypeName ==='抖音团购' || scope.row.consumptionTypeName ==='美团团购' ||
                                       scope.row.consumptionTypeName ==='口碑团购' || scope.row.consumptionTypeName ==='小程序团购' ||
                                       scope.row.consumptionTypeName ==='快手团购'"
                                       @change="orderNumHandleChange(scope.row)" :min="0" :max="1000" ></el-input-number>
                      <el-input-number v-model="scope.row.num"
                                       size="mini" :precision="0"
                                       v-if="selectedCustomerCard.balance > 0 && scope.row.consumptionParentTypeName === '次卡'"
                                       @change="orderNumHandleChange(scope.row)" :min="0" :max="ckCount" ></el-input-number>
<!--                    </div>-->
                  </div>
                  <!-- 非储值会员 -->
                  <div v-if="customer.customerType > 1">
                    <el-input-number v-model="scope.row.num"
                                     size="mini" :precision="0"
                                     v-if="scope.row.consumptionParentTypeName !== '次卡'"
                                     @change="orderNumHandleChange(scope.row)" :min="0" :max="1000" ></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="consumptionName"
                fixed="fixed"
                label="服务名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="price"
                label="标准价格">
              </el-table-column>
              <el-table-column
                align="center"
                label="会员价格">
                <template slot-scope="scope">
                  <div v-if="scope.row.type === 1">
                    <!-- 储值会员 -->
                    <div v-if="customer.customerType == 1">
<!--                      <div v-if="selectedCustomerCard === ''">-->
<!--                        {{scope.row.price}}-->
<!--                      </div>-->
                      <div v-if="selectedCustomerCard.balance === 0 || selectedCustomerCard.cardLevel === 0">
                        {{scope.row.price}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 1">
                        {{scope.row.priceDiamond}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 2">
                        {{scope.row.pricePlatinum}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 3">
                        {{scope.row.priceGold}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 4">
                        {{scope.row.priceBronze}}
                      </div>
                    </div>
                    <!-- 非储值会员 -->
                    <div v-if="customer.customerType > 1">
                      {{scope.row.price}}
                    </div>
                  </div>
                  <div v-if="scope.row.type === 2">
                    <!-- 储值会员 -->
                    <div v-if="customer.customerType == 1">
<!--                      <div v-if="selectedCustomerCard === ''">-->
<!--                        {{scope.row.price}}-->
<!--                      </div>-->
                      <div v-if="selectedCustomerCard.balance === 0 || selectedCustomerCard.cardLevel === 0">
                        {{scope.row.price}}
                      </div>
                      <div v-if="selectedCustomerCard.balance > 0 && selectedCustomerCard.cardLevel > 0">
                        {{ (scope.row.price * (selectedCustomerCard.productDiscount/100)).toFixed(2)}}
                      </div>
                    </div>
                    <!-- 非储值会员 -->
                    <div v-if="customer.customerType > 1">
                      {{scope.row.price}}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </el-drawer>

    <!-- 订单详情窗口-->
    <el-dialog
      title="消费单详情"
      :visible.sync="orderDetailDialogVisible"
      width="60%"
      @close="closeOrderDetailDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between">
          <div>
            <span>订单日期：</span>
            <el-date-picker
              v-model="value1"
              type="datetime"
              size="mini"
              readonly
              placeholder="订单日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <div>
            <span>所属门店：</span>
            <el-input v-model="orderDetail.orderOrgName" readonly size="mini" style="width: 150px"></el-input>
          </div>
          <div>
            <span>订单编号：</span>
            <el-input v-model="orderDetail.orderNo" readonly size="mini" style="width: 200px"></el-input>
          </div>
          <div>
            <span>消费人次：</span>
            <el-input v-model="orderDetail.peoples" readonly size="mini" style="width: 200px"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" v-if="updateCustomerCard != null">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="updateCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="updateCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="updateCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="updateCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="updateCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div v-if="updateCustomerCard.cardType === 2">
            <div style="width: 50%" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="updateCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 20%">可用次数：</span>
              <el-input v-model="updateCustomerCard.cardNum" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
      </el-card>
      <el-card class="box-card">
        <el-table :data="orderDetailList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="refundNum"
            label="退货数量" width="160">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.refundNum" size="mini"
                               :disabled="scope.row.detailState === 2 || tuihuoClick === true || scope.row.orgId != currentOrgId"
                               @change="refundCheck(scope.row, scope.row.refundNum)" :min="0" :max="refundMaxNum" ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="detailState"
            :formatter="orderDetailStateFormatter"
            label="状态" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            label="寄存总数量"
            prop="storeTotalNum"
            width="100">
          </el-table-column>
          <el-table-column
            align="center"
            label="寄存数量" width="160">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.storeNum" :precision="0"
                               :readonly="scope.row.type === 1 || scope.row.isStore === 1 || (scope.row.num - scope.row.refundNum) <= 0 ||
                              scope.row.orgId != currentOrgId"
                               size="mini" @change="setStoreProduct(scope.row, scope.row.storeNum)"
                               :min="0" :max="storeMaxNum" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :formatter="storeProductFormatter"
            label="寄存状态" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称" width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="num"
            label="数量" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="vipPrice"
            v-if="customer.id !== ''"
            label="会员价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            label="实收金额小计" width="100">
            <template slot-scope="scope">
              {{ (scope.row.received - scope.row.giveBalancePay).toFixed(2)}}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;">
          <div>
            <span >应收金额：</span>
            <el-input v-model="orderDetail.orderReceivable" readonly size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">会员优惠：</span>
            <el-input v-model="orderDetail.orderDiscounts" readonly size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="orderDetail.orderMoLing"  readonly size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="orderDetail.couZheng"  readonly size="mini" style="width: 60%;" />
          </div>
          <div v-if="orderDetail.isArr === 1">
            <span style="width: 10%;margin-left: 5px;">欠款金额：</span>
            <el-input v-model="orderDetail.arrearageMoney"  readonly size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 实收金额：</span>
            <el-input v-model="orderDetail.orderReceived" readonly size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}"
                  style="margin-top: 5px">
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rate"
            label="提成比例">
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <div  style="width:100%;display: flex;align-items: center">
          <div style="width:75px;">支付方式：</div>
          <div  v-for="(item, index) in orderPayTypeList" :key="index" style="display: inline-block; width: 20%;" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money" readonly
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"

            ></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" v-if="updateTicket != null" style="margin-top: 10px">
        <div  style="width:100%;">
          <div style="width:75px;">优惠券：</div>
          {{updateTicket.title}}{{updateTicket.consumptionName}}
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 5px">
        <span style="width:75px"> 备注说明：</span>
        <el-input v-model="orderDetail.comment" readonly type="textarea" size="mini"/>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeOrderDetailDialog">确 定</el-button>
        <el-button size="mini" :disabled="refundClick" @click="isFundOrder">退 费</el-button>
        <el-button size="mini" :disabled="storeClick" @click="showStockProductDialog">寄 存</el-button>
      </span>
    </el-dialog>

    <!-- 会员充值窗口-->
    <el-dialog
      title="会员卡充值"
      :visible.sync="rechargeDialogVisible"
      width="70%"
      @close="closeRechargeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
          <div style="width: 30%">
            <span style="width: 10%">充值金额：</span>
            <el-input v-model="recharge.money" @change="changeRechargeMoney"
                      placeholder="请输入充值金额" size="mini" style="width: 60%"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="width: 30%">
            <span style="width: 10%">赠送金额：</span>
            <el-input v-model="recharge.giveMoney" placeholder="请输入充值金额" size="mini" style="width: 60%"
                      :disabled="recharge.isGive === false"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="width: 30%">
            <el-checkbox v-model="recharge.isGive" @change="setGiveMethod">赠额卡</el-checkbox>
          </div>
        </div>
      </el-card>
      <el-card style="margin-top: 10px">
        <div style="display: flex;align-items: center;justify-content: flex-start;width: 100%;">
          <span style="width: 30%">卡片等级：</span>
          <el-radio-group v-model="recharge.level" style="width: 100%" :disabled="recharge.isGive === true"
                          @change="changeCustomerLevel">
            <el-radio :label="1">钻石会员</el-radio>
            <el-radio :label="2">铂金会员</el-radio>
            <el-radio :label="3">黄金会员</el-radio>
            <el-radio :label="4">大众会员</el-radio>
            <el-radio :label="0">普通会员</el-radio>
          </el-radio-group>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      :readonly="item.payEnName == 'huiyuan' || item.payEnName == 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
                    || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                    || item.payEnName == 'xiaochengxutuangou' || item.payEnName == 'kuaishoutuangou'"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      @change="changeRechargePayType" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>备注说明：</span>
      </div>
      <el-card>

        <el-input v-model="recharge.comment"  placeholder="请输入内容" type="textarea" size="mini" style="width: 100%;" />
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeRechargeDialog">取 消</el-button>
        <el-button size="mini" @click="createRecharge" :disabled="rechargeIsSubmit == 1">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改会员卡充值"
      :visible.sync="modifyRechargeDialogVisible"
      width="70%"
      @close="closeRechargeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="margin-top:20px;width: 100%"  v-if="authorities.includes('recharges.recharge.update.yizhi')">
        <el-date-picker
          v-model="value2"
          type="date"
          size="mini"
          placeholder="订单日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
          <div style="width: 30%">
            <span style="width: 10%">充值金额：</span>
            <el-input v-model="modifyRecharge.money" readonly size="mini" style="width: 60%"></el-input>
          </div>
          <div style="width: 30%">
            <span style="width: 10%">赠送金额：</span>
            <el-input v-model="modifyRecharge.giveMoney" readonly size="mini" style="width: 60%"></el-input>
          </div>
        </div>
      </el-card>
      <el-card>
        <div v-if="rechargeCustomerCard !== ''">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="rechargeCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="rechargeCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="rechargeCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="rechargeCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="rechargeCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="rechargeCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div>
            <div style="width: 50%;margin-top: 10px;" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="rechargeCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card >
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      :readonly="item.payEnName == 'huiyuan' || item.payEnName == 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
                    || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                    || item.payEnName == 'xiaochengxutuangou' || item.payEnName == 'kuaishoutuangou'"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      @change="resetModifyRechargePayType" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>备注说明：</span>
      </div>
      <el-card>
        <el-input v-model="modifyRecharge.comment"  placeholder="请输入内容" type="textarea" size="mini" style="width: 100%;" />
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeModifyRechargeDialog">取 消</el-button>
        <el-button size="mini" @click="editRecharge">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 会员退费窗口-->
    <el-dialog
      title="会员退费"
      :visible.sync="returnPremiumDialogVisible"
      width="60%"
      @close="closeReturnPremiumDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="text-align: right;margin-top: 3px">
        <el-button size="mini" plain @click="showCustomerCardDialog">选择卡别</el-button>
      </div>
      <el-card>
        <div v-if="returnPremiumCustomerCard !== ''">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="returnPremiumCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="returnPremiumCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="returnPremiumCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="returnPremiumCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="returnPremiumCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="returnPremiumCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="returnPremiumCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div v-if="returnPremiumCustomerCard.cardType === 2">
            <div style="width: 50%;margin-top: 10px;" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="returnPremiumCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="returnPremiumCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 20%">可用次数：</span>
              <el-input v-model="returnPremiumCustomerCard.cardNum" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="returnPremiumCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin-top: 5px">
        <div>
          <div style="display: flex;justify-content: flex-start;align-items: center;">
            <label style="color: #ffffff">*</label>
            <el-link icon="el-icon-warning-outline"></el-link>
            <span style="color: #FA5858">第一步，请先选择要退费的卡别</span>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center;">
            <label style="color: #ffffff">*</label>
            <el-link icon="el-icon-warning-outline"></el-link>
            <span style="color: #FA5858">第二步，输入实际退费金额</span>
            </div>
          <!--<div style="display: flex;justify-content: flex-start;align-items: center;">-->
          <!--  <label style="color: #ffffff">*</label>-->
          <!--  <el-link icon="el-icon-warning-outline"></el-link>-->
          <!--  <span style="color: #8c939d">退还优惠金额 = 会员现有余额 - 实际退费金额</span>-->
          <!--</div>-->
          <div class="input_item_con" style="display: flex;justify-content: flex-start;align-items: center;margin-top: 20px">
            <label style="color: #ffffff">*</label>
           <span style="width: 100px">会员现有余额：</span>
            <el-input v-model="returnPremiumCustomerCard.balance" readonly size="mini" style="width: 80%"></el-input>
          </div>
          <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;margin-top: 20px">
            <label style="color: #FA5858">*</label>
            <span style="width: 100px">实际退费金额：</span>
            <el-input v-model="returnPremium.money"  size="mini" style="width: 80%;"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      @change="changeReturnPremium"
                      :disabled="!returnPremiumCustomerCard"
                      @blur="checkRefund"></el-input>
          </div>
          <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;margin-top: 20px;">
            <label style="color: #ffffff">*</label>
            <span style="width: 100px">退还赠送金额：</span>
            <el-input v-model="returnPremium.giveMoney" readonly  size="mini" style="width: 80%;"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;margin-top: 20px;">
            <label style="color: #ffffff">*</label>
            <span style="width: 100px">退还优惠金额：</span>
            <el-input v-model="returnPremium.refundDiscounts" readonly placeholder="请输入内容" size="mini" style="width: 80%;"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 100%;margin-top: 20px;">
            <label style="color: #ffffff">*</label>
            <span style="width: 100px">备注说明：</span>
            <el-input type="textarea" autosize v-model="returnPremium.comment"  placeholder="请输入内容"
                      size="mini" style="width: 80%;"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items:center;width: 100%;margin-top: 20px;">
            <label style="color: #FA5858">*</label>
            <span style="width: 100px">顾客验证码：</span>
            <el-input v-model="returnPremium.checkCode" placeholder="请输入验证码" size="mini" style="width: 60%;"/>
            <el-button style="width: 20%" size="mini" @click="getCheckCode">获取验证码</el-button>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeReturnPremiumDialog">取 消</el-button>
        <el-button size="mini" @click="createRefund">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 物品窗口-->
    <el-dialog
      title="提取物品"
      :visible.sync="getProductDialogVisible"
      width="50%"
      @close="closeGetProductDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="height: 300px;padding: 20px 0;width: 100%">
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: space-between;width: 90%;height: 50px;">
          <div>
            <span style="width: 15%">产品名称：{{storeProduct.productName}}</span>
          </div>
          <div>
            <span>剩余寄存数量：{{storeProduct.storeNum}}</span>
          </div>
          <div>
            <span style="width: 15%">提取数量：</span>
            <el-input-number :disabled="storeProduct.storeNum === 0" v-model="fetchNum"
                             size="mini"
                             @change="setGetStoreMaxNum(storeProduct.storeNum)" :min="1" :max="getStoreMaxNum" label="描述文字"></el-input-number>
          </div>
        </div>

        <div style="display: flex; justify-items: flex-start;flex-direction:column;margin-top: 20px;">
          提取记录：
          <el-table :data="getProductList" fit border stripe="stripe" width="80%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              prop="storeDate"
              label="提取日期" width="200">
            </el-table-column>
            <el-table-column
              align="center"
              prop="storeNum"
              label="提取数量" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="serverName"
              label="服务人员" >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeGetProductDialog">取 消</el-button>
        <el-button size="mini" @click="createGetProduct">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="添加备注"
      :visible.sync="customerCommentDialogVisible"
      width="50%"
      @close="closeCustomerCommentDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="height: 300px;padding: 20px 0;width: 100%">
        <el-input
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="customerComment.comment">
        </el-input>
      </div>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeCustomerCommentDialog">取 消</el-button>
        <el-button size="mini" @click="createComment">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改消费单窗口-->
    <el-dialog
      title="修改消费单"
      :visible.sync="updateOrderDialogVisible"
      width="70%"
      @close="closeUpdateOrderDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="margin-top:20px;width: 100%"  v-if="authorities.includes('sales.order.update.yizhi')">
        <el-date-picker
          v-model="value1"
          type="datetime"
          size="mini"
          placeholder="订单日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div style="margin-top:10px;" v-if="updateCustomerCard != null">
        <span>卡别信息：</span>
      </div>
      <el-card v-if="updateCustomerCard != null">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="updateCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="updateCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="updateCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="updateCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="updateCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div v-if="updateCustomerCard.cardType === 2">
            <div style="width: 50%" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="updateCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 20%">可用次数：</span>
              <el-input v-model="updateCustomerCard.cardNum" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
      </el-card>
      <div style="margin-top:10px;">
        <span>消费明细：</span>
      </div>
      <el-card>
        <el-table :data="updateOrderDetailList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  height="300"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称" width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="dia"
            label="直径" width="160"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="num"
            label="数量/次数" width="160"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="vipPrice"
            label="会员价格">
          </el-table-column>
          <el-table-column
            align="center"
            label="金额小计">
            <template slot-scope="scope">
              {{ (scope.row.received - scope.row.giveBalancePay).toFixed(2)}}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>金额信息：</span>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;">
          <div>
            <span >应收金额：</span>
            <el-input v-model="updateOrderDetail.orderReceivable" readonly size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">会员优惠：</span>
            <el-input v-model="updateOrderDetail.orderDiscounts" readonly   size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="updateOrderDetail.orderMoLing"  readonly   size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="updateOrderDetail.couZheng"  readonly   size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 实收金额：</span>
            <el-input v-model="updateOrderDetail.orderReceived" readonly  size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      size="mini" style="width: 100px;margin-right: 10px;"
                      :readonly="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
                    || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                    || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                    || item.payEnName === 'kuaishoutuangou'"
                      @change="setHyUpdateOrderPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span style="width: 10%;"> 备注说明：</span>
      </div>
      <el-card>
        <el-input v-model="updateOrderDetail.comment" type="textarea" placeholder="请输入内容" size="mini" />
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeUpdateOrderDialog">取 消</el-button>
        <el-button size="mini" @click="updateOrder">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 消费单退费窗口-->
    <el-dialog
      title="消费单退费"
      :visible.sync="refundOrderMoneyDialogVisible"
      width="60%"
      @close="closeRefundOrderMoneyDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;">
          <div>
            <span>应退金额：</span>
            <el-input v-model="refundOrder.receivable" readonly  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <label style="color: #FA5858">*</label>
            <span>实退金额：</span>
            <el-input v-model="refundOrder.money"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <el-button size="mini" @click="getCheckCode">获取验证码</el-button>
            <el-input v-model="refundOrder.checkCode" placeholder="请输入验证码" size="mini" style="width: 60%;"/>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <label style="color: #FA5858">*</label>
        <span>备注说明：</span>
        <el-input v-model="refundOrder.comment"  placeholder="请输入内容" type="textarea" size="mini" style="width: 100%;" />
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeRefundOrderMoneyDialog">取 消</el-button>
        <el-button size="mini" @click="createRefundOrder">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 产品寄存-->
    <el-dialog
      title="产品寄存"
      :visible.sync="stockProductDialogVisible"
      width="40%"
      @close="closeStockProductDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;margin-top: 10px;">
        <div>
          <el-input v-model="storeProduct.checkCode"  size="mini" style="width: 60%;"/>
          <el-button size="mini" @click="getCheckCode">验证码</el-button>
        </div>
      </div>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeStockProductDialog">取 消</el-button>
        <el-button size="mini" @click="createStoreProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 订单详情窗口-->
    <el-dialog
      title="历史订单详情"
      :visible.sync="oldOrderDetailDialogVisible"
      width="40%"
      @close="closeOldOrderDetailDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="oldOrderDetailList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          align="center"
          label="退货数量" width="160">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.refundNum" size="mini"
                             @change="refundCheck(scope.row, scope.row.refundNum)" :min="0" :max="refundMaxNum" ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="项目名称" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="num"
          label="数量" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="price"
          label="标准价格" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="discountPrice"
          label="折后价格" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="salesMoney"
          label="实收金额小计">
        </el-table-column>
      </el-table>

      <div  style="width:100%;margin-top: 10px">
        <div style="width:75px;">支付方式：</div>
        <div  v-for="(item, index) in oldOrderPayTypeList" :key="index" style="display: inline-block; width: 30%;margin-top: 10px" >
          <span style="display: inline-block; width: 100px;text-align: right"> {{item.payCnName}}:</span>
          <el-input v-model="item.money"
                    placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                    disabled
          ></el-input>
          <br>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeOldOrderDetailDialog">确 定</el-button>
        <el-button size="mini" :disabled="oldOrderRefundClick" @click="isFundOldOrder">退 费</el-button>
      </span>
    </el-dialog>

    <!-- 消费单退费窗口-->
    <el-dialog
      title="历史消费单退费"
      :visible.sync="refundOldOrderMoneyDialogVisible"
      width="60%"
      @close="closeRefundOldOrderMoneyDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;">
          <div>
            <span >应退金额：</span>
            <el-input v-model="oldRefundOrder.yingtui" disabled  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span >实退金额：</span>
            <el-input v-model="oldRefundOrder.shitui"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div style="display: flex;justify-content: flex-start;align-items:center;width: 100%;">
          <el-input v-model="oldRefundOrder.checkCode" placeholder="请输入验证码" size="mini" style="width: 60%;"/>
          <el-button size="mini" @click="getOldCheckCode">验证码</el-button>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeRefundOldOrderMoneyDialog">取 消</el-button>
        <el-button size="mini" @click="createOldRefundOrder">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 还款窗口 -->
    <el-dialog
      title="还款"
      :visible.sync="hkDialogVisible"
      width="60%"
      @close="closeHkDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >应还金额：</span>
            <el-input v-model="arrOrder.arrearageMoney" readonly  placeholder="请输入内容"  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="arrMoLing" placeholder="请输入内容" size="mini"
                      style="width: 60%;" @change="setArrMoLing"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">实际还款：</span>
            <el-input v-model="sjHk" readonly placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 5px">
        <div  style="width:100%;">
          <div style="width:75px;">支付方式：</div>
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      :disabled="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
	                      || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
	                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                        || item.payEnName === 'kuaishoutuangou'"
                      @change="resetHyOrderPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeHkDialog">取 消</el-button>
        <el-button size="mini" @click="hk">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 次卡窗口 -->
    <el-dialog
      title="购买次卡"
      :visible.sync="ckDialogVisible"
      width="70%"
      @close="closeCkDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>卡别信息：</span>
        <el-button size="mini" plain @click="showShopCkDialog">选择次卡</el-button>
      </div>
      <el-card >
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%">
          <div style="width: 50%">
            <span style="width: 20%">名称：</span>
            <el-input v-model="customerCiCard.shopCk.cardTypeName" size="mini"  readonly style="width: 80%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">标准价格：</span>
            <el-input v-model="customerCiCard.shopCk.price" size="mini"  readonly style="width: 80%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%;
            margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">次数：</span>
            <el-input v-model="customerCiCard.shopCk.cardNum" size="mini"  readonly style="width: 80%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">所属门店：</span>
            <el-input v-model="customerCiCard.shopCk.shopName" size="mini"  readonly style="width: 80%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%;
            margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">适用项目：</span>
            <el-input v-model="customerCiCard.shopCk.useTypeName" size="mini"  readonly style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">有效期：</span>
            <el-input v-model="customerCiCard.shopCk.validDate" size="mini"  readonly style="width: 70%;"></el-input>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>金额信息：</span>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;">
          <div style="width: 50%">
            <span style="width: 20%;">应收金额：</span>
            <el-input v-model="customerCiCard.shopCk.money" readonly  placeholder="请输入内容"  size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 10%;margin-left: 5px;">实收金额：</span>
            <el-input v-model="customerCiCard.shopCk.money" readonly placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      :disabled="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
	                      || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
	                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                        || item.payEnName === 'kuaishoutuangou'"
                      @change="resetCkPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeCkDialog">取 消</el-button>
        <el-button size="mini" @click="buyCk">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 次卡明细 -->
    <el-dialog
      title="次卡列表"
      :visible.sync="shopCkDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeShopCkDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="shopCkList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="customerCiCard.ckIndex"
                      @change.native="selectShopCk(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardTypeName"
          label="名称" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="money"
          label="售价" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="price"
          label="标准价格">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardNum"
          label="次数">
        </el-table-column>
        <el-table-column
          align="center"
          prop="useTypeName"
          label="用途">
        </el-table-column>
        <el-table-column
          align="center"
          prop="validDate"
          label="有效期" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createName"
          label="创建人" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="modifyTime"
          label="最后更新时间" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="modifyName"
          label="最后更新人" width="200">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="shopCkCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="shopCkPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="shopCkPageTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 次卡明细 -->
    <el-dialog
      title="卡别列表"
      :visible.sync="customerCardDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeCustomerCardDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="customerCardList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="selectCardIndex"
                      :disabled="scope.row.state === 2 || scope.row.state === 9"
                      @change.native="selectCustomerCard(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardTypeName"
          label="名称" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardLevel"
          :formatter="cardLevelFormatter"
          label="卡等级">
        </el-table-column>
        <el-table-column
          align="center"
          prop="balance"
          label="余额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="giveBalance"
          label="赠额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardNum"
          label="次数">
        </el-table-column>
        <el-table-column
          align="center"
          prop="shopName"
          label="所属门店" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          :formatter="cardStateFormatter"
          label="状态">
        </el-table-column>
        <el-table-column
          align="center"
          prop="useTypeName"
          label="用途">
        </el-table-column>
        <el-table-column
          align="center"
          prop="validDate"
          label="有效期" width="150">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="cardSizeChange"
          @current-change="cardCurrentChange"
          :current-page="cardCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="cardPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="cardPageTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑次卡记录"
      :visible.sync="modifyCustomerCkDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeModifyCustomerCk"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">卡别名称：</span>
            <el-input v-model="modifyBuyCk.cardTypeName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">所属门店：</span>
            <el-input v-model="modifyBuyCk.shopName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">适用项目：</span>
            <el-input v-model="modifyBuyCk.useTypeName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">卡有效期：</span>
            <el-date-picker
              v-model="modifyBuyCk.validDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini">
            </el-date-picker>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">可用次数：</span>
            <el-input v-model="modifyBuyCk.cardNum" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">剩余次数：</span>
            <el-input v-model="modifyBuyCk.syNum" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeModifyCustomerCk">取 消</el-button>
        <el-button size="mini" @click="editCustomerBuyCk">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 卡别管理 -->
    <el-dialog
      title="卡别管理"
      :visible.sync="modifyCustomerCardDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeModifyCustomerCard"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">卡别名称：</span>
            <el-input v-model="modifyCustomerCard.cardTypeName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">所属门店：</span>
            <el-input v-model="modifyCustomerCard.shopName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">会员等级：</span>
            <el-select v-model="modifyCustomerCard.cardLevel" :disabled="modifyCustomerCard.cardType > 1"
                       size="mini" placeholder="请选择">
              <el-option
                v-for="item in levelArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">适用项目：</span>
            <el-input v-model="modifyCustomerCard.useTypeName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
             v-if="modifyCustomerCard.cardType < 3">
          <div style="width: 50%">
            <span style="width: 20%">账户余额：</span>
            <el-input v-model="modifyCustomerCard.balance" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">卡有效期：</span>
            <el-input v-model="modifyCustomerCard.validDate" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
        <div v-if="modifyCustomerCard.cardType === 2" style="margin-top: 10px">
          <div style="width: 50%" >
            <span style="width: 20%">赠送金额：</span>
            <el-input v-model="modifyCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
             v-if="modifyCustomerCard.cardType === 3">
          <div style="width: 50%">
            <span style="width: 20%">可用次数：</span>
            <el-input v-model="modifyCustomerCard.cardNum" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">卡有效期：</span>
            <el-date-picker
              v-model="modifyCustomerCard.validDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini">
            </el-date-picker>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeModifyCustomerCard">取 消</el-button>
        <el-button size="mini" @click="editCustomerCard">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 优惠券明细 -->
    <el-dialog
      title="优惠券列表"
      :visible.sync="customerTicketDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeCustomerTicketDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="customerTicketList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="selectTicketIndex"
                      :disabled="scope.row.isUse === 2"
                      @change.native="selectCustomerTicket(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="优惠券名成"
          align="center" width="150">
        </el-table-column>
        <el-table-column
          prop="ticketTypeName"
          label="优惠券类型"
          align="center" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="money"
          label="面额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="fullMoney"
          label="满金额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="subMoney"
          label="减金额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="rate"
          label="折扣率" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="单品名称" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="validDate"
          label="有效期" width="150">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="ticketHandleSizeChange"
          @current-change="ticketHandleCurrentChange"
          :current-page="ticketCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="ticketPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="ticketPageTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return {
      areaId: window.sessionStorage.getItem('areaId'),
      orgLevel: window.sessionStorage.getItem('orgLevel'),
      rechargeIsSubmit:2, //充值是否提交，1是 2否
      orderIsSubmit:2, //消费单是否提交，1是 2否
      tableHeight:'',
      value1:'',
      value2:'',
      xfhj:'',      //消费合计
      czhj:'',      //充值合计
      tfhj:'',      //退费合计
      yhhj:'',      //优惠合计
      customerLevelDialogVisible:false,
      isMain:true,
      isMainText:'',
      userId:'',
      currentOrgId:'',
      moLingRate:'',
      customerId:'',
      orgName:'',
      fukaName:'',
      authorities:'',
      saleList:[],
      consumptionTypeFilterText:'',
      customer:{
        level:'',
        balance:'',
        giveBalance:'',
        profession:'',
        customerType:'',
        source:'',
        knife:'',
        customerNo:'',
        birthday:'',
        productDiscount:'',
        totalBalance:'',
        relevanceCustomers:[],
        oldOrderList:[],
        byRelevanceCustomer:'',
        footDiseases:[],
        pastDiseases:[],
        customerName:'',
        main:'',
        openId:'',
        phone:''
      },
      customerBuyCkList:[],
      consumptionTypeList:[],
      consumptionList:[],
      consumptionShowList:[],
      consumptionTypeProps:{
        label: 'consumptionTypeName',
        children: 'children'
      },
      customerTypeArr:{1:'储值类',2:'康复类',3:'非储值类'},
      dangerArr:{1:'男',2:'女'},
      sourceArr:{0:'无', 1:'附近居民',2:'附近工作',3:'偶遇', 4:'附近办事', 5:'朋友介绍', 6:'广告', 7:'活动卡', 8:'其他'},
      professionArr:{0:'无',
        1:'企业',
        2:'事业单位',
        3:'政府',
        4:'学生',
        5:'无业',
        6:'退休'
      },
      levelArr:[
        {value:1, label:'钻石会员'},
        {value:2, label:'铂金会员'},
        {value:3, label:'黄金会员'},
        {value:4, label:'大众会员'},
        {value:0, label:'普通会员'}
      ],
      stateArr:{
        1:'已支付',
        2:'部分退费',
        3:'全部退费',
        4:'已作废'
      },
      stateText:[
        {state:1, name:'已支付'},
        {state:2, name:'部分退费'},
        {state:3, name:'全部退费'},
        {state:4, name:'已作废'}
      ],
      bindTypeText:[
        {type:1, name:'绑定'},
        {type:2, name:'解绑'},
      ],
      orderDialogVisible:false,
      order:{
        customer:'',
        orderOrgId:'',
        orderOrgName:'',
        receivable:0,
        discounts:0,
        received:0,
        consumptions:[],
        balancePay:0,
        cashPay:0,
        weChatPay:0,
        aliPay:0,
        bankPay:0,
        lakalaPay:0,
        posPay:0,
        miniWeChatPay:0,
        scanCodePay:0,
        giveBalancePay: 0,
        productDiscount:0,
        servers:[],
        orderType:'',
        main:'',
        moLing:0,
        couZheng:0,
        orderPayTypeList:[],
        isLocal:2,
        viceName:'',
        modifier:'',
        creator:'',
        comment:'',
        peoples:'',
        isArrearage:'',
        isArr:'',
        arrearageMoney:0,
        customerCard:'',
        selectedTicket:'',
        customerType:''
      },
      //订单支付方式属性
      payTypeBalance:true,
      payTypeCash:true,
      payTypeWeChat:true,
      payTypeAliPay:true,
      payTypeBank:true,
      payTypeLkl:true,

      productDrawer:false,
      isMolingSet:false,
      //订单详情窗口
      orderDetailDialogVisible:false,
      orderDetail:{
        aliPay:'',
        balancePay:'',
        bankPay:'',
        cashPay:'',
        creator:'',
        id:'',
        lakalaPay:'',
        orderDate:'',
        orderDiscounts:'',
        orderNo:'',
        orderOrgId:'',
        orderOrgName:'',
        orderReceivable:'',
        orderReceived:'',
        serverName:'',
        state:'',
        orderMoLing:'',
        couZheng:'',
        phone:'',
        comment:''
      },
      updateOrderDetail:'',
      updateOrderDetailList:[],
      orderDetailList:[],
      orderDetailStateText:[
        {detailState:1,name:'已支付'},
        {detailState:2,name:'已退费'}
      ],
      today:'',
      //会员充值窗口部分内容
      rechargeDialogVisible:false,
      rechargeList:[],
      recharge:{
        payType: '',
        money:'',
        level:0,
        //现金支付金额
        cashPay:'',
        //微信支付金额
        weChatPay:'',
        //支付宝支付金额
        aliPay:'',
        //银行卡支付金额
        bankPay:'',
        //拉卡拉支付金额
        lakalaPay:'',
        posPay:'',
        miniWeChatPay:'',
        scanCodePay:'',
        //会员id
        customerId:'',
        orgId:'',
        serverId:'',
        creator:'',
        //赠送金额
        giveMoney:'',
        main:'',
        rechargePayTypeList:[],
        modifier:'',
        accountName:'',
        servers:[],
        serverName:'',
        viceName:'',
        phone:'',
        openId:'',
        orgName:'',
        comment:'',
        isGive:false,
        giveState:0
      },
      rechargeStateText:[
        {state:1,name:'已充值'},
        {state:2,name:'已作废'}
      ],
      returnPremiumStateText:[
        {state:1,name:'已退费'},
        {state:2,name:'已作废'}
      ],
      //会员退费部分内容
      returnPremiumDialogVisible:false,
      returnPremium:{
        money:'',
        refundDiscounts:'',
        comment:'',
        serverId:'',
        customerId:'',
        creator:'',
        orgId:'',
        giveMoney: '',
        viceName:'',
        phone:'',
        checkCode:'',
        customerName:'',
        orgName:'',
        customerCard:''
      },
      consumptionQueryText:'',
      //数据类型  1表示服务  2表示产品
      dataType:'',
      consumptionTypeId:'',
      totalPay:'',

      storeProductList:[],
      getProductDialogVisible:false,
      storeProduct:{
        id:'',
        productId:'',
        productName:'',
        storeNum:'',
        orgId:'',
        type:'',
        orderId:'',
        customerId:'',
        getNum:'',
        checkCode:'',
        creator:'',
        orderDetails:[]
      },
      getProductList:[],
      //提取数量
      fetchNum:'',
      storeStateText:[
        {isStore:1,name:'已寄存'},
        {isStore:2,name:'未寄存'}
      ],

      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,

      currentPage3: 1,
      pageSize3:20,
      pageTotal3:0,

      currentPage4: 1,
      pageSize4:20,
      pageTotal4:0,

      selectServerList:[],
      serverDialogVisible:false,
      queryServerText:'',
      serverList:[],
      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,
      rateTotal:0,
      maxMoLingMoney:'',
      orgPayTypeList:[],
      orderPayTypeList:[],
      orgActivityList:[],
      xianjin:0,
      rechargeMoney:0,
      rechargeDoubleClick:false,
      returnPremiumList:[],
      returnPremiumCustomerCard:'',

      currentPage5: 1,
      pageSize5:20,
      pageTotal5:0,

      //物品提取设置
      getStoreMaxNum:999,
      refundMaxNum:999,
      storeMaxNum:999,
      refundClick:true,
      storeClick:true,
      createOrderDoubleClick:false,
      shishou:0,
      kuaishoutuangou:0,
      douyintuangou:0,
      meituantuangou:0,
      koubeituangou:0,
      xiaochengxutuangou:0,

      customerCommentDialogVisible:false,
      customerComment:{
        comment:'',
        customerId:'',
        orgName:'',
        orgId:'',
      },
      currentPage6: 1,
      pageSize6:20,
      pageTotal6:0,
      customerComments:[],
      tuihuoClick:false,
      bindCustomerRecord:[],
      currentPage7: 1,
      pageSize7:20,
      pageTotal7:0,
      currentPage8: 1,
      pageSize8:20,
      pageTotal8:0,
      refundOrder:{
        orgId:'',
        orderId:'',
        receivable:'',
        money:'',
        orderDetailList:[],
        viceName:'',
        type:'',
        customerId:'',
        serverId:'',
        phone:'',
        checkCode:'',
        openId:'',
        comment:'',
        customerCard:''
      },
      updateOrderDialogVisible:false,
      refundOrderMoneyDialogVisible:false,
      stockProductDialogVisible:false,
      refundOrderDoubleClick:false,
      storeProductDoubleClick:false,
      refundRechargeDoubleClick:false,
      createCommentDoubleClick:false,
      nowDate:'',
      submitText:[
        {isSubmit:1, name:'已提交'},
        {isSubmit:2, name:'未提交'},
      ],
      customerRequest:{
        pageNum:'',
        pageSize:'',
        customerId:'',
        shopId:''
      },
      oldOrderData:[],
      oldOrderDetailList:[],
      oldOrderPayTypeList:[],
      oldOrderDetailDialogVisible:false,
      refundOldOrderMoneyDialogVisible:false,
      oldOrder:{
        id:'',
        orgId:'',
        customerId:'',
        phone:'',
      },
      oldRefundOrder:{
        orderId:'',
        payType:'',
        money:0,
        checkCode:'',
        orgId:'',
        refundNum:0,
        yingtui:0,
        shitui:0,
        customerId:'',
        phone:'',
        oldOrderDetailList:[],
        creator:''
      },
      refundOldOrderDoubleClick:false,
      oldOrderRefundClick:false,
      oldOrderStateText:[
        {orderType:1,name:'已退费'},
        {orderType:0,name:'已结账'}
      ],
      isHyCouZhengSet:false,

      arrOrderList:[],
      arrStateText:[
        {state:1,name:'欠款中'},
        {state:2,name:'已还款'},
      ],
      hkDialogVisible:false,
      arrOrder:'',
      sjHk:'',
      arrMoLing:'',
      qiankuan:0,
      arrOrderRequest:{
        memberId:'',
        pageNum:'',
        pageSize:''
      },
      currentPage9: 1,
      pageSize9:20,
      pageTotal9:0,
      arrOrderStateText:[
        {state:1,name:'欠款中'},
        {state:2,name:'已还款'},
      ],

      ckDialogVisible:false,
      customerCiCard:{
        shopId:'',
        ckIndex:'',
        shopCk:'',
        customerId:'',
        servers:[],
        ckPayTypeList:[],
        creator:''
      },
      shopCkDialogVisible:false,
      shopCkList:[],
      baseRequest:{
        shopId:'',
        pageNum:'',
        pageSize:'',
        customerId:'',
        main:0
      },
      shopCkCurrentPage: 1,
      shopCkPageSize:20,
      shopCkPageTotal:0,
      customerCkList:[],

      selectedCustomerCard:'',
      updateCustomerCard:'',
      ckCount:0,
      ciCardMoney:0,
      selectCardIndex:'',
      customerCardDialogVisible:false,
      customerCardList:[],
      cardCurrentPage: 1,
      cardPageSize:20,
      cardPageTotal:0,
      cardText:[
        {cardLevel:0, name:'普通会员'},
        {cardLevel:1, name:'钻石会员'},
        {cardLevel:2, name:'铂金会员'},
        {cardLevel:3, name:'黄金会员'},
        {cardLevel:4, name:'大众会员'}
      ],
      cardStateText:[
        {state:1, name:'正常'},
        {state:2, name:'过期'},
        {state:9, name:'跨区域'},
        {state:4, name:'已作废'},
      ],
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        consumptionId:''
      },
      modifyCustomerCard:'',
      modifyCustomerCardDialogVisible:false,
      modifyCustomerCkDialogVisible:false,
      modifyBuyCk:'',
      modifyRechargeDialogVisible:false,
      rechargeCustomerCard:'',
      modifyRecharge:'',
      selectedCustomerTicket:'',
      customerTicketDialogVisible:false,
      customerTicketList:[],
      selectTicketIndex:'',
      ticketCurrentPage: 1,
      ticketPageSize:20,
      ticketPageTotal:0,
      ticketCount:0,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      lockDate:'',
      updateTicket:''
    }
  },
  watch: {
    consumptionTypeFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  methods:{
    showModifyCustomerCk(row){
      this.modifyBuyCk = row;
      this.modifyCustomerCkDialogVisible = true;
    },
    closeModifyCustomerCk(){
      this.modifyCustomerCkDialogVisible = false;
    },
    async editCustomerBuyCk(){
      const {data:res} = await this.$http.post(`/edit/buy/ck`, this.modifyBuyCk);
      if (res.code == 200){
        this.$message.success("操作成功！")
      }
      this.closeModifyCustomerCk();
    },
    async loadLockDate(){
      const {data:res} = await this.$http.get(`/load/lock/date`)
      if(res.data != null){
        this.lockDate = res.data;
      }
    },
    disabledDate(time){
      // return time.getTime() <= Date.parse('2023-07-31') - 8.64e7;
      return time.getTime() <= Date.parse(this.lockDate) - 8.64e7;
    },
    async loadCustomer(){
      const {data:res} = await this.$http.get(`/customer/customerId/${this.customerId}/orgId/${this.currentOrgId}`);
      this.customer = res.data;
      if (res.data.main === 1){
        this.isMain = false;
        this.isMainText = '主卡';
      }
      if (res.data.main === 2){
        this.isMainText = '副卡';
      }
      await this.loadCustomerOrderCount();
      await this.loadCustomerOrder();
      await this.loadCustomerRechargeCount();
      await this.loadCustomerRecharge();
      await this.loadBindRecordCount();
      await this.loadBindRecord();
      await this.oldOrderCount();
      await this.oldOrderList();
    },
    clearOrder(){
      this.order.id = '';
      this.order.orderDate = '';
      this.order.state = '';
      this.order.num = '';
      this.order.customerId = '';
      this.order.customerName = '';
      this.order.orderOrgId = '';
      //应收金额
      this.order.receivable = '';
      //优惠金额
      this.order.orderDiscounts = '';
      //实收金额
      this.order.received = '';
      //商品和服务
      this.order.consumptions = [];
      //服务人员
      this.order.serverId = '';
      //会员余额支付金额
      this.order.balancePay = '';
      //现金支付金额
      this.order.cashPay = '';
      //微信支付金额
      this.order.weChatPay = '';
      //支付宝支付金额
      this.order.aliPay = '';
      //银行卡支付金额
      this.order.bankPay = '';
      //拉卡拉支付金额
      this.order.lakalaPay = '';
      this.order.posPay = '';
      this.order.miniWeChatPay = '';
      this.order.scanCodePay = '';
      //会员等级
      this.order.level = '';
      //产品折扣
      this.order.productDiscount = '';
      //1.表示会员  2.表示散客
      this.order.orderType = '';
      //服务人员
      this.order.servers = [];
      this.order.giveBalancePay = '';
      this.order.moLing = '';
      this.order.orderPayTypeList = [];
      this.order.isLocal = 2;
      this.order.openId = '';
      this.order.orderOrgName = '';
      this.order.modifier = '';
      this.order.balance = '';
    },
    showOrderDialog(){
      this.initHyOrder();
      this.isMolingSet = false;
      this.isHyCouZhengSet = false;
      this.consumptionShowList = [];
      this.selectServerList = [];         //已选择的服务人员置空
      this.selectedCustomerCard = '';
      this.selectedCustomerTicket = '';
      this.order.isArrearage = false;
      this.orgPayTypeList.map(item => {   //所有的支付方式置空
        item.money = '';
      })
      this.loadCustomerKyTicketCount();
      this.orderDialogVisible = true;
    },
    initHyOrder(){
      this.order.customer='';    //消费单会员信息
      this.order.receivable = '';
      this.order.orderDiscounts = '';
      this.order.received = '';
      this.order.consumptions = [];
      this.order.balancePay = '';
      this.order.cashPay = '';
      this.order.weChatPay = '';
      this.order.aliPay = '';
      this.order.bankPay = '';
      this.order.lakalaPay = '';
      this.order.posPay = '';
      this.order.miniWeChatPay = '';
      this.order.scanCodePay = '';
      this.order.giveBalancePay = '';
      this.order.moLing = '';
      this.order.couZheng = '';
      this.order.servers = [];
      this.order.orderPayTypeList = [];
      this.order.isLocal = 2;
      this.order.orderOrgId = this.currentOrgId;
      this.order.creator = this.userId;
      this.order.modifier = '';
      this.order.comment = '';
      this.order.peoples = '';
    },
    toDetail(item){
      this.$router.push({path:'/card',query:{id:item, fukaName: this.customer.customerName}});
      if (location.href.indexOf("#reloaded")<=0) {
        location.href = location.href + "#reloaded"+"#reloaded";
        location.reload();
      }
    },
    closeOrderDialog(){
      this.orderDialogVisible = false;
    },
    async consumptionTypeHandleNodeClick(data){
      this.dataType = data.type;
      if (data.consumptionTypeName === '服务分类'){
        this.dataType = 1;
      }
      if (data.consumptionTypeName === '产品分类'){
        this.dataType = 2;
      }
      this.consumptionTypeId = data.consumptionTypeId;
      this.consumptionTypeId = data.consumptionTypeId;
      if (data.consumptionParentTypeName === '次卡'){
        await this.loadCkConsumption();
      } else {
        await this.loadConsumption();
      }
    },
    async loadCkConsumption(){
      this.consumptionRequest.dateType = this.dataType;
      this.consumptionRequest.consumptionId = this.selectedCustomerCard.consumptionId;
      this.consumptionRequest.orgId = this.currentOrgId
      const {data:res} = await this.$http.post(`/load/ck/consumption`, this.consumptionRequest)
      this.consumptionList = res.data;
    },
    loadConsumption(){
      this.consumptionRequest.dateType = this.dataType;
      this.consumptionRequest.typeId = this.consumptionTypeId;
      this.consumptionRequest.orgId = this.currentOrgId
      this.consumptionRequest.pageNum = 1;
      this.consumptionRequest.pageSize = 1000;
      // this.loadConsumptionCount();
      this.loadConsumptionList();
    },
    async loadConsumptionCount(){
      const {data:res} = await this.$http.post(`/load/count/consumption`, this.consumptionRequest)
      this.pageTotal4 = res.totalPage;
    },
    async loadConsumptionList(){
      const {data:res} = await this.$http.post(`/load/list/consumption`, this.consumptionRequest)
      this.consumptionList = res.data;
    },
    //计算订单金额
    getOrderReceived(){
      let receivable = 0; //应收金额
      let received = 0; //实收金额
      this.kuaishoutuangou=0;
      this.douyintuangou=0;
      this.meituantuangou=0;
      this.koubeituangou=0;
      this.xiaochengxutuangou=0;
      let result = true;
      this.consumptionShowList.map((item) => {
        if (item.consumptionTypeName !== '抖音团购' && item.consumptionTypeName !== '美团团购'
            && item.consumptionTypeName !== '口碑团购' && item.consumptionTypeName !== '小程序团购'
            && item.consumptionTypeName !== '活动修脚' && item.consumptionTypeName !== '快手团购'){
          result = false;
        }
        if (item.isShowDia === 1){   //是否包含直径类消费项目
          if (item.dia !== undefined){
            receivable += item.price * item.num * item.dia;
            received += item.price * item.num * item.dia;
          }
        }
        if (item.isShowDia !== 1){
          if (item.type ===1){
            receivable += item.price * item.num;
            if (item.consumptionTypeName === '快手团购'){
              this.kuaishoutuangou += item.price * item.num;
            }
            if (item.consumptionTypeName === '抖音团购'){
              this.douyintuangou += item.price * item.num;
            }
            if (item.consumptionTypeName === '美团团购'){
              this.meituantuangou += item.price * item.num;
            }
            if (item.consumptionTypeName === '口碑团购'){
              this.koubeituangou += item.price * item.num;
            }
            if (item.consumptionTypeName === '小程序团购'){
              this.xiaochengxutuangou += item.price * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 0){
              received += item.price * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 1){
              received += item.priceDiamond * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 2){
              received += item.pricePlatinum * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 3){
              received += item.priceGold * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 4){
              received += item.priceBronze * item.num;
            }
          }
          if (item.type ===2){
            receivable += item.price * item.num;
            received += item.price * (this.selectedCustomerCard.productDiscount / 100) * item.num;
          }
        }
      })
      this.isMolingSet = result;
      this.order.received = Number(received.toFixed(2));
      this.order.receivable = Number(receivable.toFixed(2));
      this.order.orderDiscounts = Number((receivable - received).toFixed(2));
    },
    hyOrderNoLevelAmount(){
      this.ciCardMoney = 0;
      let receivable = 0; //应收金额
      let result = true;
      this.consumptionShowList.map((item) =>{
        if (item.consumptionTypeName !== '抖音团购' && item.consumptionTypeName !== '美团团购'
          && item.consumptionTypeName !== '口碑团购' && item.consumptionTypeName !== '小程序团购'
          && item.consumptionTypeName !== '活动修脚' && item.consumptionTypeName !== '快手团购'){
          result = false;
        }
        if (item.consumptionParentTypeName === '次卡'){
          this.ciCardMoney = item.price * item.num;
        }
        if (item.isShowDia === 1){   //是否显示直径
          if (item.dia !== undefined){
            receivable += item.price * item.num * item.dia;
          }
        } else {
          if (item.consumptionTypeName === '快手团购'){
            this.kuaishoutuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '抖音团购'){
            this.douyintuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '美团团购'){
            this.meituantuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '口碑团购'){
            this.koubeituangou += item.price * item.num
          }
          if (item.consumptionTypeName === '小程序团购'){
            this.xiaochengxutuangou += item.price * item.num
          }
          receivable += item.price * item.num;
        }
      })
      this.isMolingSet = result;
      this.order.receivable = Number(receivable.toFixed(2));
      this.order.received = Number(receivable.toFixed(2));
      this.order.orderDiscounts = 0;
    },
    checkBalance(){
      if (this.order.balancePay > this.selectedCustomerCard.balance){
        this.order.balancePay = this.selectedCustomerCard.balance;
      }
    },
    orderNumHandleChange(value){
      let result = true;
      for (let i = 0; i < this.consumptionShowList.length; i++) {
        if (this.consumptionShowList[i].id === value.id && value.num > 0){
          this.consumptionShowList[i].num = value.num;
          result = false;
        }

        if (this.consumptionShowList[i].id === value.id && value.num === 0){
          this.consumptionShowList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.consumptionShowList.push(value);
      }
    },
    deleteConsumptionShowList(index,rows){
      rows.splice(index, 1);
      this.order.moLing = 0;
      this.order.couZheng=0;
      this.isMolingSet=false;
      this.isHyCouZhengSet=false;
      this.selectedCustomerTicket = '';
      //消费项目发生了变化，重新计算订单金额
      this.jsHyOrderAmount();
      this.setPayMoney();
    },
    consumptionTypeFilterNode(value, data) {
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    setMoLing(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsHyOrderAmount();
      let maxMoLingMoney = Number((this.order.receivable * this.moLingRate / 100).toFixed(2));
      let hyOrderMoLing = Number(this.order.moLing);
      let giveBalancePay = Number(this.order.giveBalancePay);
      let couzheng = Number(this.order.couZheng);
      if (hyOrderMoLing > maxMoLingMoney){
        this.$message.warning("抹零金额不能超过应收金额的" + this.moLingRate + "%");
        this.order.moLing = 0;
        return;
      }
      this.isHyCouZhengSet = true;
      this.order.received = Number((this.order.receivable - this.order.orderDiscounts
        - hyOrderMoLing - giveBalancePay + couzheng).toFixed(2));
      // this.shishou = this.order.received;
      this.selectedCustomerTicket = '';
      this.setPayMoney();
    },
    //创建订单
    async createOrder(){
      if (this.consumptionShowList.length === 0){
        this.$message.warning("请添加消费明细！")
        return;
      }
      if (this.order.peoples < 1){
        this.$message.warning("请填写消费人次！")
        return;
      }
      if (this.selectServerList.length === 0){
        this.$message.warning("请添加服务人员！")
        return;
      }
      //如果选择的是次卡来支付消费单，那么所选择的消费项目里必须包含该次卡所对应的消费项目
      if(this.selectedCustomerCard.cardType === 3){
        let checked = true;
        this.consumptionShowList.map((item)=>{
          if(item.id == this.selectedCustomerCard.consumptionId){
            checked = false;
          }
        })
        if(checked){
          this.$message.warning("您所选择的消费项目里没有该次卡对应的消费项目！")
          return;
        }
      }

      if (this.order.isArrearage === true && (this.order.arrearageMoney === '' || this.order.arrearageMoney === 0)){
        this.$message.warning("请输入欠款金额！");
        return;
      }
      let totalMoney = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'zengsonghuiyuan'){
          totalMoney += item.money - 0;
        }
      })

      let hj = (this.order.arrearageMoney - 0) + (this.order.received - 0);
      let yj = (this.order.receivable-0) - (this.order.orderDiscounts-0) - (this.order.moLing - 0)
        - (this.order.giveBalancePay - 0) + (this.order.couZheng);
      if (this.order.isArrearage === true && this.order.arrearageMoney > 0){
        if (hj.toFixed(2) != yj){
          this.$message.warning("支付金额 与 实收金额+欠款金额的和 不一致，请仔细检查");
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          return;
        }
      } else {
        if ((this.order.received -0 ).toFixed(2) !== totalMoney.toFixed(2)){
          this.$message.warning("支付金额与实收金额不一致，请仔细检查");
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          return;
        }
      }
      // if (this.order.isArrearage === true && this.order.arrearageMoney > 0){
      //   let hj = Number(Number(this.order.arrearageMoney) + this.order.received);
      //   if (hj != (this.order.receivable - this.order.orderDiscounts - this.order.moLing
      //         - this.order.giveBalancePay + this.order.couZheng)){
      //     return this.$message.warning("支付金额 与 实收金额+欠款金额的和 不一致，请仔细检查");
      //   }
      // } else {
      //   if (this.order.received !== totalMoney){
      //     return this.$message.warning("支付金额与实收金额不一致，请仔细检查");
      //   }
      // }
      let result = false;
      this.consumptionShowList.map((item) => {
        if (item.isShowDia === 1 && (item.dia === undefined || item.dia === 0)){
          result = true;
        }
      })
      if(result){
        return this.$message.warning("请填写直径毫米数");
      }

      this.order.customer = this.customer;
      this.order.orderOrgId = this.currentOrgId;
      this.order.creator = this.userId;
      this.order.consumptions = this.consumptionShowList;
      this.order.servers = this.selectServerList;
      this.order.orderPayTypeList = this.orgPayTypeList;
      this.order.orderOrgName = this.orgName;
      if(this.selectedCustomerCard != ''){
        this.order.customerCard = this.selectedCustomerCard;
      } else {
        this.order.customerCard = null;
      }
      if(this.selectedCustomerTicket != ''){
        this.order.selectedTicket = this.selectedCustomerTicket;
      } else {
        this.order.selectedTicket = null;
      }

      this.order.customerType = this.customer.customerType;
      if (this.fukaName !== undefined){
        this.order.viceName = this.fukaName;
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.orderIsSubmit = 1;
      const {data:res} = await this.$http.post(`/order/hyOrder`,this.order);
      if (res.code === 200){
        this.saleList = res.data;
        this.orderIsSubmit = 2;
      }
      this.orderDialogVisible = false;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadCustomerTotalPay();
      this.loadCustomerCard();
      await this.loadCustomer();
      await this.loadArrOrderList();
    },

    //查询该会员消费单个数
    async loadCustomerOrderCount(){
      const {data:res} = await this.$http.get(`/order/count/customerId/${this.customerId}`);
      this.pageTotal = res.totalPage;
    },

    //查询该会员的消费单
    async loadCustomerOrder(){
      const {data:res} = await this.$http.get(`/order/customerId/${this.customerId}/main/${this.customer.main}/pageNum/${this.currentPage}/pageSize/${this.pageSize}`);
      this.saleList = res.data;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadCustomerOrder();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCustomerOrder();
    },
    async isCancelOrder(row){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/order/is/cancel`, row);
      if(res.data === true) {
        this.$message.warning("此消费单存在寄存并提取的物品，所以不能作废！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }

      if(row.cardId > 0){
        const {data:res1} = await this.$http.get(`/load/one/customerCard/${row.cardId}`);
        if (res1.data.validDate <= this.nowDate && res1.data.cardType === 3){
          this.$message.error("该消费单使用次卡消费，次卡现已过期，不允许作废");
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          return ;
        }
      }

      await this.cancelOrder(row);
    },
    async cancelOrder(row){
      const {data:res} = await this.$http.post(`/order/cancel/${this.userId}`, row);
      this.saleList = res.data;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadCustomer();
      this.loadCustomerCard();
      await this.loadCustomerOrder();
      await this.loadCustomerTotalPay();
    },
    dataFormatter(row,column){
      let data = row[column.property];
      if(data === null){
        return null;
      }
      let dt = new Date(data);
      return dt.getFullYear() + '-' + (dt.getMonth()+1) + '-' + dt.getDate();
    },
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 4 && columnIndex ===2){
        return 'color:#EA1B28';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#FAAC58';
      } else if (row.state === 3 && columnIndex ===2){
        return 'color:#ff1a1a';
      }
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    bindFormatter(row){
      let value = "";
      for (let i = 0; i < this.bindTypeText.length; i++){
        let item = this.bindTypeText[i];
        if (row.type === item.type) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async showConsumptionDialog(){
      this.productDrawer = true;
      this.consumptionList = [];
      const {data:res} = await this.$http.get(`/consumptionType/orgId/${this.currentOrgId}`)
      this.consumptionTypeList = res.data;
    },
    closeConsumptionDialog(){
      this.selectedCustomerTicket = '';
      this.order.moLing = 0;
      this.order.couZheng = 0;
      this.order.arrearageMoney = 0;
      this.jsHyOrderAmount();
      this.setPayMoney();
      this.productDrawer = false;
    },
    clearTuanGou(){
      this.kuaishoutuangou = 0;
      this.douyintuangou = 0;
      this.meituantuangou = 0;
      this.xiaochengxutuangou = 0;
      this.koubeituangou = 0;
    },
    jsHyOrderAmount(){
      this.clearTuanGou();
      //储值会员
      if (this.customer.customerType == 1){
        if(this.selectedCustomerCard === ''){
          this.hyOrderNoLevelAmount();
        } else {
          if (this.selectedCustomerCard.cardType == 1){
            this.getOrderReceived();
            if (this.selectedCustomerCard.cardType == 2){
              this.getGiveMoneyPay();
            }
          } else {
            this.hyOrderNoLevelAmount();
            if (this.selectedCustomerCard.cardType == 2){
              this.getGiveMoneyPay();
            }
          }
        }
      } else {
        this.hyOrderNoLevelAmount();
      }
      // this.setPayMoney();
    },
    changeNumReceived(){
      this.getOrderReceived();
      this.getGiveMoneyPay();
      this.setPayMoney();
    },
    getGiveMoneyPay(){
      if (this.selectedCustomerCard.giveBalance === 0){
        this.order.giveBalancePay = 0;
      } else {
        let giveRate = (this.selectedCustomerCard.giveBalance /
          (this.selectedCustomerCard.balance + this.selectedCustomerCard.giveBalance)).toFixed(2);
        this.order.giveBalancePay = (this.order.received * giveRate).toFixed(2);
        if (this.order.giveBalancePay >= this.selectedCustomerCard.giveBalance){
          this.order.giveBalancePay = this.selectedCustomerCard.giveBalance;
        }
      }

      //计算完成后，需要重新计算订单的实际支付金额
      this.order.received = (this.order.received - this.order.giveBalancePay).toFixed(2);
    },
    async showOrderDetailDialog(data){
      this.updateCustomerCard = '';
      this.orderDetail = data;
      this.value1 = data.createTime;
      this.order.customerId = data.customerId;
      this.storeProduct.customerId = data.customerId;
      this.orderDetail.orderMoLing = data.moLing;
      this.order.state = data.state;
      if (data.state === 4){
        this.tuihuoClick = true;
      } else {
        this.tuihuoClick = false;
      }
      const {data:res} = await this.$http.get(`/orderDetail/orderId/${data.id}`)
      this.orderDetailList = res.data;

      const {data:res1} = await this.$http.get(`/order/payType/orderId/${data.id}`)
      this.orderPayTypeList = res1.data;

      const {data:res3} = await this.$http.get(`/load/order/ticket/orderId/${data.id}`)
      this.updateTicket = res3.data;

      // if(data.cardId > 0){
        const {data:res2} = await this.$http.get(`/load/one/customerCard/${data.cardId}`)
        this.updateCustomerCard = res2.data;
      if(this.updateCustomerCard != null) {
        this.getCardLevelName(this.updateCustomerCard);
        // }
      }

      await this.queryOrderServers(data);
      this.orderDetailDialogVisible = true;
    },
    async queryOrderServers(data){
      const {data:res} = await this.$http.get(`/orderDetail/server/orderId/${data.id}`)
      this.selectServerList = res.data;
    },
    changeZj(){
      this.selectedCustomerTicket = '';
      this.jsHyOrderAmount();
      this.setPayMoney();
      this.order.moLing=0;
      this.order.couZheng=0;
      this.isMolingSet=false;
      this.isHyCouZhengSet=false;
    },
    closeOrderDetailDialog(){
      this.orderDetailDialogVisible = false;
    },
    createOrderDetailRefund(){
      this.loadCustomer();
      this.loadCustomerOrder();
      this.loadCustomerStoreProduct();
      this.orderDetailDialogVisible = false;
    },
    async isFundOrder(){
      let consumptionId = 0;
      this.orderDetailList.map((item) => {
        if (item.consumptionParentTypeName === '次卡'){
          consumptionId = item.consumptionId;
        }
      })
      if (consumptionId > 0){
        const {data:res} = await this.$http.get(`/load/customerCard/consumptionId/${consumptionId}`);
        if (res.data.validDate <= this.nowDate){
          return this.$message.error("次卡已过期，不允许退费");
        }
      }
      let money = 0;
      this.orderPayTypeList.map((item) =>{
        if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan'){
          money += (item.money - 0);
        }
      })
      let message = '';
      if (money > 0 || this.orderDetail.isArr === 1){
        message = '退回到现金！'
        this.refundOrder.type = 2 ;
      } else {
        message = '退回到会员！'
        this.refundOrder.type = 1;
      }
      this.$confirm(message, '退费提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.RefundOrderCheck();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退费'
        });
      });
    },
    RefundOrderCheck(){
      let result = false;
      for (let i = 0; i < this.orderDetailList.length; i++) {
        if (this.orderDetailList[i].isRefund === 2 && this.orderDetailList[i].isStore === 1 &&
          this.orderDetailList[i].refundNum > (this.orderDetailList[i].storeTotalNum - this.orderDetailList[i].getNum)){
          result = true;
        }
      }
      if (result){
        this.$confirm("该消费单的产品退费数量 > 该产品的寄存数量，是否继续退费", '退费提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.showRefundOrderMoneyDialog();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退费'
          });
        });
      } else {
        this.showRefundOrderMoneyDialog();
      }
    },
    showRefundOrderMoneyDialog(){
      this.refundOrder.money = '';
      this.refundOrder.checkCode = '';
      this.refundOrder.orgId = this.orderDetail.orderOrgId;
      this.refundOrder.orderId = this.orderDetail.id;
      this.refundOrder.customerId = this.orderDetail.customerId;
      this.refundOrder.serverId = this.userId;
      this.refundOrder.viceName = this.customer.customerName;
      this.refundOrder.openId = this.customer.openId;
      this.refundOrder.customerCard = this.updateCustomerCard;
      if (this.fukaName !== ''){
        this.refundOrder.viceName = this.fukaName;
      }
      let yingtui = 0;
      this.orderDetailList.map((item) => {
        if (item.refundNum > 0 && item.isRefund == 2){
          if (item.isShowDia === 1){
            yingtui += item.received - item.giveBalancePay - 0;
          } else {
            yingtui += ((item.received / item.num) * item.refundNum - (item.giveBalancePay / item.num))  - 0;
          }
        }
      })
      this.refundOrder.receivable = yingtui.toFixed(2);
      this.refundOrderMoneyDialogVisible = true;
    },
    closeRefundOrderMoneyDialog(){
      this.refundOrderMoneyDialogVisible = false;
    },
    async createRefundOrder(){
      if (this.refundOrder.money === ''){
        return this.$message.warning("请填写退费金额！");
      }
      if (this.refundOrder.receivable -0  < this.refundOrder.money -0){
        return this.$message.warning("实退金额 > 应退金额，请核对！");
      }
      if (this.refundOrder.checkCode === ''){
        return this.$message.warning("请输入验证码");
      }
      if (this.refundOrder.comment === ''){
        return this.$message.warning("请填写备注信息！");
      }
      this.refundOrder.phone = this.orderDetail.phone;
      this.refundOrder.orderDetailList = this.orderDetailList;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post('/order/refund', this.refundOrder);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      if (res.code === 401){
        return this.$message.error("验证码无效！")
      }
      this.orderDetailList = res.data;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeRefundOrderMoneyDialog();
      this.closeOrderDetailDialog();
      await this.loadCustomer();
      await this.loadCustomerOrder();
      await this.loadCustomerTotalPay();
    },

    orderDetailStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.orderDetailStateText.length; i++){
        let item = this.orderDetailStateText[i];
        if (row.detailState === item.detailState) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //会员充值部分代码
    showRechargeDialog(){
      this.recharge.money = '';
      this.recharge.giveMoney = '';
      this.recharge.comment = '';
      this.recharge.isGive = false;
      this.orgPayTypeList.map((item) => {
        item.money = '';
      })
      this.selectServerList = [];
      this.rechargeDialogVisible = true;
    },
    setGiveMethod(){
      if (this.recharge.isGive){
        this.recharge.giveState = 1;
      } else {
        this.recharge.giveState = 2;
      }
    },
    async loadRechargeServers(id){
      const {data:res} = await this.$http.get(`/recharge/detail/server/rechargeId/${id}`)
      this.selectServerList = res.data;
    },
    async loadRechargeById(id){
      const {data:res} = await this.$http.get(`/recharge/id/${id}`);
      this.modifyRecharge = res.data;
      this.value2 = res.data.rechargeDate;
    },
    closeRechargeDialog(){
      this.rechargeDialogVisible = false;
    },
    async loadRechargePayType(id){
      const {data:res} = await this.$http.get(`/recharge/orgPayType/id/${id}`);
      let rechargePayType = res.data;
      this.initRechargePayType(rechargePayType);
    },
    initRechargePayType(rechargePayType){
      this.orgPayTypeList.map((item) => {
        rechargePayType.map((index) => {
          if (index.payEnName === item.payEnName){
            item.money = index.money - 0;
          }
        })
      })
    },
    rechargeStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.rechargeStateText.length; i++){
        let item = this.rechargeStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    returnPremiumStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.returnPremiumStateText.length; i++){
        let item = this.returnPremiumStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async cancelCustomerCk(row){
      const {data:res} = await this.$http.post(`/cancel/ci/card`, row);
      if (res.code == 200){
        this.$message.success("操作成功！")
      }
      await this.loadCustomerBuyCkList();
    },
    oldOrderStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.oldOrderStateText.length; i++){
        let item = this.oldOrderStateText[i];
        if (row.orderType === item.orderType) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    rechargeStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#EA1B28';
      }
    },
    async createRecharge(){
      this.rechargeIsSubmit = 1;
      if (this.recharge.money ==  0){
        return this.$message.warning("请填写大于0的充值金额");
      }
      if (this.recharge.money === ''){
        return this.$message.warning("请填写充值金额");
      }
      if (this.selectServerList.length === 0){
        return this.$message.warning("请添加服务人员！");
      }
      if (this.recharge.isGive === true && this.recharge.giveMoney === ''){
        return this.$message.warning("请输入赠送金额！");
      }
      this.recharge.main = this.customer.main;
      this.recharge.customerId = this.customerId;
      this.recharge.customerName = this.customer.customerName;
      this.recharge.orgId = this.currentOrgId;
      this.recharge.creator = this.userId;
      this.recharge.accountName = this.customer.customerName;
      this.recharge.servers = this.selectServerList;
      this.recharge.viceName = this.customer.customerName;
      this.recharge.orgName = this.orgName;
      this.recharge.phone = this.customer.phone;
      this.recharge.openId = this.customer.openId;
      if (this.fukaName !== undefined){
        this.recharge.viceName = this.fukaName;
      }
      let totalPay = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'zengsonghuiyuan'){
          totalPay += (item.money - 0);
        }
      })
      if ((this.recharge.money -0) !== totalPay){
        return this.$message.warning("充值金额与支付方式金额的和不一致，请检查！");
      }
      this.recharge.rechargePayTypeList = this.orgPayTypeList;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/add/recharge`,this.recharge);
      if (res.code === 200){
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        this.$message.success("操作成功！");
        this.rechargeIsSubmit = 2;
      } else {
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        this.$message.error("操作失败！");
        this.rechargeIsSubmit = 1;
      }
      this.closeRechargeDialog();
      // this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadCustomerTotalPay();
      await this.loadCustomer();
      this.loadCustomerCard();
      await this.loadCustomerRecharge();
    },
    async editRecharge(){
      if (this.selectServerList.length === 0){
        this.$message.warning("请添加服务人员！")
        return;
      }
      this.modifyRecharge.servers = this.selectServerList;
      this.modifyRecharge.rechargePayTypeList = this.orgPayTypeList;
      this.modifyRecharge.rechargeDate = this.value2;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/update/recharge`, this.modifyRecharge);
      if (res.code === 200){
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        this.$message.success("操作成功！");
      } else {
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        this.$message.error("操作失败！");
      }
      this.closeModifyRechargeDialog();
      await this.loadCustomerTotalPay();
      await this.loadCustomer();
      await this.loadCustomerRecharge();
    },
    async cancelRecharge(row){
      const {data:res} = await this.$http.get(`/load/one/customerCard/${row.cardId}`);
      if (res.data.balance < row.money){
        return this.$message.error("该充值记录金额>卡片金额，不允许作废");
      } else {
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
        const {data:res} = await this.$http.post(`/recharge/cancel`,row);
        this.rechargeList = res.data;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        await this.loadCustomer();
        await this.loadCustomerRecharge();
      }
    },
    changeCustomerLevel(value){
      this.recharge.level = value;
    },
    //查询该会员充值记录个数
    async loadCustomerRechargeCount(){
      const {data:res} = await this.$http.get(`/recharge/count/customerId/${this.customerId}`);
      this.pageTotal1 = res.totalPage;
    },
    //查询该会员的充值记录
    async loadCustomerRecharge(){
      this.baseRequest.pageNum = this.currentPage1;
      this.baseRequest.pageSize = this.pageSize1;
      this.baseRequest.customerId = this.customerId;
      this.baseRequest.main = this.customer.main;
      const {data:res} = await this.$http.post(`/load/recharge/customerId`, this.baseRequest);
      this.rechargeList = res.data;
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadCustomerRecharge();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadCustomerRecharge();
    },
    showReturnPremiumDialog(){
      this.returnPremium.money = '';
      this.returnPremium.checkCode = '';
      this.orderDetail.phone = this.customer.phone;
      this.returnPremium.phone = this.customer.phone;
      this.returnPremium.refundDiscounts = '';
      this.returnPremium.comment = '';
      this.returnPremium.customerCard = '';
      this.returnPremiumCustomerCard = '';
      this.returnPremiumDialogVisible = true;
    },
    closeReturnPremiumDialog(){
      this.returnPremiumDialogVisible = false;
    },
    //检查退费金额是否正确
    checkRefund(){
      if (this.returnPremium.money > this.returnPremiumCustomerCard.balance){
        this.returnPremium.money = this.returnPremiumCustomerCard.balance;
      }
    },
    async createRefund(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if (this.returnPremiumCustomerCard === ''){
        this.$message.warning("请选择卡别！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      if (this.returnPremiumCustomerCard.balance === 0){
        this.$message.warning("没有可退的余额")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      if ((this.returnPremium.refundDiscounts - 0) > this.returnPremiumCustomerCard.balance){
        this.$message.warning("退还优惠金额不能>会员余额！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      if ((this.returnPremium.money - 0) < 0){
        this.$message.warning("请输入退还金额！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      if (this.returnPremium.checkCode === ''){
        this.$message.warning("请输入验证码")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      this.returnPremium.customerId = this.customerId;
      this.returnPremium.serverId = this.userId;
      this.returnPremium.creator = this.userId;
      this.returnPremium.orgId = this.currentOrgId;
      this.returnPremium.customerName = this.customer.customerName;
      this.returnPremium.orgName = this.orgName;
      this.returnPremium.viceName = this.customer.customerName;
      this.returnPremium.customerCard = this.returnPremiumCustomerCard;
      if(this.fukaName !== undefined){
        this.returnPremium.viceName = this.fukaName;
      }

      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/recharge/returnPremium`, this.returnPremium);
      if (res.code === 200){
        this.$message.success("退费成功");
      }
      if (res.code === 401){
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return this.$message.error("验证码无效！")
      }
      if (res.code === 500){
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return this.$message.error("系统异常或者退费金额为空，请检查退费金额")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeReturnPremiumDialog();
      await this.loadReturnPremiumCount();
      await this.loadReturnPremium();
      await this.loadCustomer();
      this.loadCustomerCard();
      await this.loadCustomerTotalPay();
    },
    //关键字查询产品的方法
    async queryConsumption(){
      if (this.consumptionQueryText === ''){
        this.consumptionQueryText = null;
      }
      const {data:res} = await this.$http.get(`/consumption/type/${this.dataType}/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${this.consumptionQueryText}/pageNum/${this.currentPage4}/pageSize/${this.pageSize4}`)
      this.consumptionList = res.data.list;
      this.pageTotal4 = res.data.total;
    },
    async loadCustomerTotalPay(){
      const {data:res} = await this.$http.get(`/customer/amount/customerId/${this.customerId}`)
      this.xfhj = res.data.xfhj;
      this.tfhj = res.data.tfhj;
      this.czhj = res.data.czhj;
      this.yhhj = res.data.yhhj;
    },
    async loadCustomerStoreProduct(){
      const {data:res} = await this.$http.get(`/customer/store/customerId/${this.customerId}/pageNum/${this.currentPage3}/pageSize/${this.pageSize3}`)
      this.storeProductList = res.data.list;
      this.pageTotal3 = res.data.total;
    },
    handleSizeChange3(val) {
      this.pageSize3 = val;
      this.loadCustomerStoreProduct();
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val;
      this.loadCustomerStoreProduct();
    },
    showGetProductDialog(data){
      this.storeProduct = data;
      this.fetchNum = '';
      this.loadGetStoreProduct();
      this.getProductDialogVisible = true;
    },
    closeGetProductDialog(){
      this.getProductDialogVisible = false;
    },
    async createGetProduct(){
      if (this.fetchNum === '' || this.fetchNum === '0' || this.storeProduct.storeNum === 0){
        this.closeGetProductDialog();
      } else {
        this.storeProduct.getNum = this.fetchNum;
        this.storeProduct.creator = this.userId;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
        const {data:res} = await this.$http.post(`/store/get`, this.storeProduct);
        this.getProductList = res.data;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        await this.loadCustomerStoreProduct();
        this.closeGetProductDialog();
      }
    },
    async loadGetStoreProduct(){
      const {data:res} = await this.$http.get(`/store/get/store/${this.storeProduct.id}`);
      this.getProductList = res.data;
    },
    async setStoreProduct(row){
      this.storeMaxNum = row.num - row.refundNum;
      let flag = false;
      this.orderDetailList.map((item) => {
        if (item.storeNum > 0){
          flag = true;
          this.storeClick = false;
        }
      })
      if (flag === false){
        this.storeClick = true;
      }
    },
    storeProductFormatter(row){
      let value = "";
      for (let i = 0; i < this.storeStateText.length; i++){
        let item = this.storeStateText[i];
        if (row.isStore === item.isStore) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //寄存物品方法
    async createStoreProduct(){
      this.storeClick = true;
      this.storeProduct.creator = this.userId;
      this.storeProduct.orderDetails = this.orderDetailList;
      this.storeProductDoubleClick = true;
      const {data:res} = await this.$http.post(`/order/store`, this.storeProduct)
      if (res.code === 200){
        this.storeProductDoubleClick = false;
        this.$message.success("操作成功！")
        this.orderDetailList = res.data;
      }
      if (res.code === 401){
        this.storeProductDoubleClick = false;
        return this.$message.error("验证码无效！")
      }
      this.orderDetailList = res.data;
      await this.loadCustomerStoreProduct();
      this.closeStockProductDialog();

    },
    showServerDialog(){
      this.loadServer();
      this.serverDialogVisible = true;
    },
    async loadServer(){
      const {data:res} = await this.$http.get(`/users/valida/${2}/orgId/${this.currentOrgId}/pageNum/${this.currentPage2}/pageSize/${this.pageSize2}`)
      this.serverList = res.data.list;
      this.pageTotal2 = res.data.total;
    },
    closeServerDialog(){
      this.resetHyOrderUserRate();
      this.serverDialogVisible = false;
    },
    resetHyOrderUserRate(){
      let rateTotal = 0;
      if (this.selectServerList.length > 0){
        this.selectServerList.map((item, index) => {
          if (index === this.selectServerList.length -1){
            let rate = 100 - rateTotal;
            item.rate = rate.toFixed(2)
          } else {
            item.rate = (100 / this.selectServerList.length).toFixed(2);
            rateTotal += item.rate - 0;
          }
        })
      }
    },
    serverSelectChange(val){
      this.selectServerList = val;
    },
    deleteServerShowList(index,rows){
      rows.splice(index, 1);
      this.resetHyOrderUserRate();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.loadServer();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.loadServer();
    },
    handleSizeChange4(val) {
      this.pageSize4 = val;
      this.loadConsumptionList();
    },
    handleCurrentChange4(val) {
      this.currentPage4 = val;
      this.loadConsumptionList();
    },
    setHyOrderUserRate(){
      let rateTotal = 0;
      this.selectServerList.map((item, index) =>{
        if (index === this.selectServerList.length-1){
          let rate = 100 - rateTotal;
          if (rate <= 0){
            item.rate = 0;
          } else {
            item.rate = rate.toFixed(2);
          }
        } else {
          rateTotal += item.rate - 0;
        }
      })
    },
    async loadOrgPayType(){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${this.currentOrgId}`)
      this.orgPayTypeList = res.data;
    },
    changeOrderPayMoney(){
      this.$nextTick(() => {
        //定义一个临时的支付方式数组，记录下都输入了哪些支付方式
        let tempPayType = [];
        this.orgPayTypeList.map((item) => {
          if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan' &&
            item.payEnName !== 'meituantuangou' && item.payEnName !== 'douyintuangou' &&
            item.payEnName !== 'xiaochengxutuangou' && item.payEnName !== 'koubeituangou'
            && item.payEnName !== 'kuaishoutuangou'
          ) {
            if (item.money > 0) {
              let payType = {
                payEnName: item.payEnName,
                money: item.money - 0
              }
              tempPayType.push(payType);
            }
          }
        })

        //清空除团购和赠送之外所有的支付方式
        this.orgPayTypeList.map((item) => {
          if (item.payEnName !== 'zengsonghuiyuan' &&
            item.payEnName !== 'meituantuangou' && item.payEnName !== 'douyintuangou' &&
            item.payEnName !== 'xiaochengxutuangou' && item.payEnName !== 'koubeituangou'
            && item.payEnName !== 'kuaishoutuangou'
          ) {
            item.money = ''
          }
        })

        let totalMoney = this.order.received;
        if (this.customer.customerType == 1) {
          if (this.selectedCustomerCard.cardType === 3) {
            this.orgPayTypeList.map((item) => {
              if (item.payEnName === 'huiyuan') {
                item.money = this.ciCardMoney;
              }
            })
            let ckMoney = 0;
            let xianjin = parseFloat((this.order.received - this.ciCardMoney).toFixed(2));
            this.orgPayTypeList.map((item) => {
              tempPayType.map((tempItem) => {
                if (item.payEnName === tempItem.payEnName && item.payEnName !== 'xianjin') {
                  if ((xianjin - ckMoney) < tempItem.money) {
                    item.money = xianjin - ckMoney
                  }
                  if ((xianjin - ckMoney) === tempItem.money) {
                    item.money = xianjin - ckMoney
                  }
                  if ((xianjin - ckMoney) > tempItem.money) {
                    item.money = tempItem.money
                  }
                  ckMoney += tempItem.money - 0
                }
              })
            })
            this.orgPayTypeList.map((item) => {
              if (item.payEnName === 'xianjin') {
                if (xianjin - ckMoney <= 0) {
                  item.money = 0;
                } else {
                  item.money = xianjin - ckMoney;
                }
              }
            })
          } else {
            let money = 0;
            if (this.selectedCustomerCard.balance > 0) {
              let tempMoney = totalMoney - money;
              let inputXian = 0;
              this.orgPayTypeList.map((item) => {
                tempPayType.map((tempItem) => {
                  if (item.payEnName === tempItem.payEnName && item.payEnName !== 'xianjin'
                    && item.payEnName !== 'huiyuan') {
                    if (tempMoney < tempItem.money) {
                      item.money = parseFloat(tempMoney.toFixed(2))
                    }
                    if (tempMoney === tempItem.money) {
                      item.money = parseFloat(tempMoney.toFixed(2))
                    }
                    if (tempMoney > tempItem.money) {
                      item.money = parseFloat(tempItem.money.toFixed(2))
                    }
                    money += item.money
                    tempMoney = totalMoney - money;
                  }
                  if(tempItem.payEnName == 'xianjin'){
                    inputXian = tempItem.money;
                  }
                })
              })

              let otherTotal = 0;
              this.orgPayTypeList.map((item) => {
                if (item.money > 0 && item.payEnName !== 'huiyuan') {
                  otherTotal += item.money - 0;
                }
              })

              if(otherTotal + inputXian == totalMoney){
                this.orgPayTypeList.map((item) => {
                  if (item.payEnName === 'xianjin') {
                      item.money = parseFloat(inputXian.toFixed(2))
                  }
                })
              } else {
                let huiyuan = totalMoney - money;
                this.orgPayTypeList.map((item) => {
                  if (item.payEnName === 'huiyuan') {
                    if (huiyuan <= this.selectedCustomerCard.balance) {
                      if (huiyuan <= 0) {
                        item.money = 0;
                      } else {
                        item.money = parseFloat(huiyuan.toFixed(2));
                        money += item.money;
                      }
                    }
                    if (huiyuan > this.selectedCustomerCard.balance) {
                      item.money = this.selectedCustomerCard.balance;
                      money += item.money;
                    }
                  }
                })

                if(inputXian == totalMoney - otherTotal){
                  this.orgPayTypeList.map((item) => {
                    if (item.payEnName === 'huiyuan'){
                      item.money = 0;
                    }
                    if (item.payEnName === 'xianjin') {
                      if (inputXian > 0) {
                        item.money = parseFloat(inputXian.toFixed(2))
                      } else {
                        item.money = 0;
                      }
                    }
                  })
                } else {
                  let xianjin = totalMoney - money;
                  this.orgPayTypeList.map((item) => {
                    if (item.payEnName === 'xianjin') {
                      if (xianjin > 0) {
                        item.money = parseFloat(xianjin.toFixed(2))
                      } else {
                        item.money = 0;
                      }
                    }
                  })
                }
              }


            }
          }
        } else {
          let meituan = 0;
          let douyin = 0;
          let kuaishou = 0;
          let koubei = 0;
          let xiaochengxu = 0;
          this.orgPayTypeList.map((item) => {
            if (item.payEnName == 'meituantuangou'){
              meituan = item.money;
            }
            if (item.payEnName == 'douyintuangou'){
              douyin = item.money;
            }
            if (item.payEnName == 'xiaochengxutuangou'){
              xiaochengxu = item.money;
            }
            if (item.payEnName == 'koubeituangou'){
              koubei = item.money;
            }
            if (item.payEnName == 'kuaishoutuangou'){
              kuaishou = item.money;
            }
          })

          let fcMoney = 0;
          //可支配金额
          let kzpMoney = parseFloat((this.order.received - meituan - douyin - koubei - kuaishou - xiaochengxu).toFixed(2));
          this.orgPayTypeList.map((item) => {
            tempPayType.map((tempItem) => {
              if (item.payEnName === tempItem.payEnName && item.payEnName !== 'xianjin') {
                if ((kzpMoney - fcMoney) < tempItem.money) {
                  item.money = parseFloat((kzpMoney - fcMoney).toFixed(2));
                }
                if ((kzpMoney - fcMoney) === tempItem.money) {
                  item.money = tempItem.money
                }
                if ((kzpMoney - fcMoney) > tempItem.money) {
                  item.money = tempItem.money
                }
                fcMoney += item.money;
              }
            })
          })
          let xian = kzpMoney - fcMoney;
          this.orgPayTypeList.map((item) => {
            if (item.payEnName === 'xianjin') {
              if (xian > 0) {
                item.money = parseFloat(xian.toFixed(2))
              } else {
                item.money = ''
              }
            }
          })
        }
      })
      // let totalMoney = this.order.received;
      // let money = 0;
      // if (this.customer.customerType == 1){
      //   if(this.selectedCustomerCard === ''){
      //     this.orgPayTypeList.map((item) => {
      //       if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
      //         if (item.money > (totalMoney - money)){
      //           item.money = (totalMoney - money).toFixed(2);
      //         }
      //         money += item.money - 0;
      //       }
      //     })
      //     this.orgPayTypeList.map((item) => {
      //       if (item.payEnName === 'xianjin'){
      //         if ((totalMoney - money) < 0){
      //           item.money = 0;
      //         } else {
      //           item.money = (totalMoney - money).toFixed(2);
      //         }
      //       }
      //     })
      //   } else {
      //     if (this.selectedCustomerCard.cardType === 3){
      //       let xianjin = (this.hyOrder.received - this.ciCardMoney).toFixed(2);
      //       this.orgPayTypeList.map((item) =>{
      //         if (item.payEnName === 'huiyuan'){
      //           item.money = this.ciCardMoney;
      //         }
      //       })
      //       this.orgPayTypeList.map((item) => {
      //         if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan'
      //           && item.payEnName !== 'xianjin'){
      //           if (item.money > (xianjin-money)){
      //             item.money = (xianjin-money).toFixed(2);
      //           }
      //           money += item.money - 0;
      //         }
      //       })
      //       this.orgPayTypeList.map((item) => {
      //         if (item.payEnName === 'xianjin' ){
      //           if (xianjin-money <= 0){
      //             item.money = 0;
      //           } else {
      //             item.money = xianjin-money;
      //           }
      //         }
      //       })
      //     } else {
      //       if (this.selectedCustomerCard.balance === 0){
      //         this.orgPayTypeList.map((item) => {
      //           if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
      //             if (item.money > (totalMoney - money)){
      //               item.money = (totalMoney - money).toFixed(2);
      //             }
      //             money += item.money - 0;
      //           }
      //         })
      //         this.orgPayTypeList.map((item) => {
      //           if (item.payEnName === 'xianjin'){
      //             if ((totalMoney - money) < 0){
      //               item.money = 0;
      //             } else {
      //               item.money = (totalMoney - money).toFixed(2);
      //             }
      //           }
      //         })
      //       }
      //       if (this.selectedCustomerCard.balance > 0){
      //         this.orgPayTypeList.map((item) => {
      //           if (item.payEnName !== 'huiyuan' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
      //             money += item.money - 0;
      //           }
      //         })
      //         this.orgPayTypeList.map((item) => {
      //           if (item.payEnName === 'huiyuan'){
      //             if ((totalMoney - money) <= this.selectedCustomerCard.balance){
      //               if (totalMoney - money < 0){
      //                 item.money = 0;
      //               } else {
      //                 item.money = (totalMoney - money).toFixed(2);
      //               }
      //             }
      //             if ((totalMoney - money) > this.selectedCustomerCard.balance){
      //               item.money = this.customer.balance;
      //             }
      //           }
      //         })
      //       }
      //     }
      //   }
      //
      // } else {
      //   this.orgPayTypeList.map((item) => {
      //     if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
      //       if (item.money > (totalMoney - money)){
      //         item.money = (totalMoney - money).toFixed(2);
      //       }
      //       money += item.money - 0;
      //     }
      //   })
      //   this.orgPayTypeList.map((item) => {
      //     if (item.payEnName === 'xianjin'){
      //       if ((totalMoney - money) < 0){
      //         item.money = 0;
      //       } else {
      //         item.money = (totalMoney - money).toFixed(2);
      //       }
      //     }
      //   })
      // }
    },
    setHyUpdateOrderPay(){
      let kuaishoutuangou = 0;
      let douyintuangou = 0;
      let meituantuangou=0;
      let koubeituangou=0;
      let xiaochengxutuangou=0;
      let huiyuan = 0;
      let money = 0;
      let needPay = 0;
      this.updateOrderDetailList.map((item) =>{
        if (item.consumptionTypeName === '快手团购'){
          kuaishoutuangou += item.received;
        }
        if (item.consumptionTypeName === '抖音团购'){
          douyintuangou += item.received;
        }
        if (item.consumptionTypeName === '美团团购'){
          meituantuangou += item.received;
        }
        if (item.consumptionTypeName === '口碑团购'){
          koubeituangou += item.received;
        }
        if (item.consumptionTypeName === '小程序团购'){
          xiaochengxutuangou += item.received;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'huiyuan'){
          huiyuan += item.money - 0;
        }
      })
      needPay = (this.updateOrderDetail.orderReceived - kuaishoutuangou -  meituantuangou - douyintuangou
        - koubeituangou - xiaochengxutuangou - huiyuan).toFixed(2);
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan' && item.payEnName !== 'xianjin'){
          if (item.money >= (needPay - money)){
            item.money = (needPay - money).toFixed(2);
          }
          money += item.money - 0;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          item.money = (needPay - money).toFixed(2);
        }
      })
    },
    cikaStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===6){
        return 'color:#0CB618';
      } else if (row.state === 4 && columnIndex ===6){
        return 'color:#EA1B28';
      } else if (row.state === 2 && columnIndex ===6){
        return 'color:#FAAC58';
      } else if (row.state === 3 && columnIndex ===6){
        return 'color:#ff1a1a';
      }
    },
    changeRechargePayType(){
      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (this.recharge.money - money)){
              item.money = this.recharge.money - money;
          }
          money += item.money - 0;
        }
      })

      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if (this.recharge.money - money < 0){
            item.money = 0;
          } else {
            item.money = this.recharge.money - money;
          }
        }
      })
    },
    resetModifyRechargePayType(){
      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (this.modifyRecharge.money - money)){
            item.money = this.modifyRecharge.money  - money;
          }
          money += item.money - 0;
        }
      })

      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if (this.modifyRecharge.money - money <= 0){
            item.money = 0;
          } else {
            item.money = this.modifyRecharge.money - money;
          }
        }
      })
    },
    changePayMoney(){
      let totalMoney = this.xianjin;
      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (this.xianjin - money)){
            item.money = this.xianjin - money;
          }
          money += item.money - 0;
        }
      })
      this.xianjin = totalMoney;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((this.xianjin - money) < 0){
            item.money = 0;
          } else {
            item.money = this.xianjin - money;
          }
        }
      })
    },
    changeRechargeMoney(){
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          item.money = this.recharge.money;
        }
      })
    },
    changeReturnPremium(){
      if(this.returnPremiumCustomerCard == ''){
        this.$message.warning("请选择卡别")
        return;
      }
      if (this.returnPremium.money - 0 > this.returnPremiumCustomerCard.balance - 0){
        this.returnPremium.money = this.returnPremiumCustomerCard.balance;
      }
      this.returnPremium.refundDiscounts = (this.returnPremiumCustomerCard.balance - this.returnPremium.money).toFixed(2);
    },

    async loadReturnPremiumCount(){
      const {data:res} = await this.$http.get(`/returnPremium/count/customerId/${this.customerId}`)
      this.pageTotal5 = res.totalPage;
    },
    async loadReturnPremium(){
      const {data:res} = await this.$http.get(`/returnPremium/customerId/${this.customerId}/pageNum/${this.currentPage5}/pageSize/${this.pageSize5}`)
      this.returnPremiumList = res.data;
    },
    handleSizeChange5(val) {
      this.pageSize5 = val;
      this.loadReturnPremium();
    },
    handleCurrentChange5(val) {
      this.currentPage5 = val;
      this.loadReturnPremium();
    },
    async cancelReturnPremium(data){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/returnPremium/cancel`, data)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadReturnPremium();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadCustomer();
    },
    setGetStoreMaxNum(data){
      this.getStoreMaxNum = data;
    },
    refundCheck(row){
      this.refundMaxNum = row.num;
      let flag = false;
      this.orderDetailList.map((item) => {
        if (item.refundNum > 0){
          flag = true;
          this.refundClick = false;
        }
      })
      if (flag === false){
        this.refundClick = true;
      }
    },
    setPayMoney(){
      //先将设置过的全部清空
      this.orgPayTypeList.map((item) =>{
        item.money = '';
      })
      //储值会员的计算方式
      if (this.customer.customerType == 1){
        if(this.selectedCustomerCard === ''){
          let received = this.order.received;
          let tempMoney1 = Number((received - this.kuaishoutuangou - this.meituantuangou
              - this.douyintuangou - this.koubeituangou - this.xiaochengxutuangou).toFixed(2));
          // let xianjin = (tempMoney - this.selectedCustomerCard.balance).toFixed(2);
          this.orgPayTypeList.map((item) =>{
            if (item.payEnName === 'xianjin'){
              if (tempMoney1 < 0){
                item.money = 0;
              } else {
                item.money = tempMoney1;
              }
            }
            if (item.payEnName === 'kuaishoutuangou'){
              item.money = Number(this.kuaishoutuangou.toFixed(2));
            }
            if (item.payEnName === 'meituantuangou'){
              item.money = Number(this.meituantuangou.toFixed(2));
            }
            if (item.payEnName === 'douyintuangou'){
              item.money = Number(this.douyintuangou.toFixed(2));
            }
            if (item.payEnName === 'koubeituangou'){
              item.money = Number(this.koubeituangou.toFixed(2));
            }
            if (item.payEnName === 'xiaochengxutuangou'){
              item.money = Number(this.xiaochengxutuangou.toFixed(2));
            }
          })
        } else {
          //判断卡类别，如果是次卡，则只需要
          if (this.selectedCustomerCard.cardType === 3){
            let xianjin = Number((this.order.received - this.ciCardMoney).toFixed(2));
            this.orgPayTypeList.map((item) =>{
              if (item.payEnName === 'huiyuan'){
                item.money = this.ciCardMoney;
              }
              if(item.payEnName === 'xianjin'){
                item.money = xianjin;
              }
            })
          } else {
            let tempMoney = Number((this.order.received - this.kuaishoutuangou
                - this.meituantuangou - this.douyintuangou - this.koubeituangou
                - this.xiaochengxutuangou).toFixed(2));
            let xianjin = Number((tempMoney - Number(this.selectedCustomerCard.balance)).toFixed(2));
            if (this.selectedCustomerCard.balance === 0){
              this.orgPayTypeList.map((item) =>{
                if (item.payEnName === 'xianjin'){
                  if (tempMoney < 0){
                    item.money = 0;
                  } else {
                    item.money = tempMoney;
                  }
                }
                if (item.payEnName === 'kuaishoutuangou'){
                  item.money = Number(this.kuaishoutuangou.toFixed(2));
                }
                if (item.payEnName === 'meituantuangou'){
                  item.money = Number(this.meituantuangou.toFixed(2));
                }
                if (item.payEnName === 'douyintuangou'){
                  item.money = Number(this.douyintuangou.toFixed(2));
                }
                if (item.payEnName === 'koubeituangou'){
                  item.money = Number(this.koubeituangou.toFixed(2));
                }
                if (item.payEnName === 'xiaochengxutuangou'){
                  item.money = Number(this.xiaochengxutuangou.toFixed(2));
                }
              })
            }

            if (this.selectedCustomerCard.balance > 0){
              for(let i = 0; i < this.orgPayTypeList.length; i++){
                if (this.orgPayTypeList[i].payEnName === 'huiyuan'){
                  if(tempMoney >= this.selectedCustomerCard.balance){
                    this.orgPayTypeList[i].money = this.selectedCustomerCard.balance;
                  } if(tempMoney < 0){
                    this.orgPayTypeList[i].money = 0;
                  }
                  if (tempMoney < this.selectedCustomerCard.balance && tempMoney > 0) {
                    this.orgPayTypeList[i].money = tempMoney;
                  }
                }
                if(this.orgPayTypeList[i].payEnName === 'xianjin'){
                  if (xianjin > 0) {
                    this.orgPayTypeList[i].money = xianjin;
                  }
                }
                if (this.orgPayTypeList[i].payEnName === 'kuaishoutuangou'){
                  this.orgPayTypeList[i].money = Number(this.kuaishoutuangou.toFixed(2));
                }
                if (this.orgPayTypeList[i].payEnName === 'zengsonghuiyuan'){
                  this.orgPayTypeList[i].money = this.order.giveBalancePay;
                }
                if (this.orgPayTypeList[i].payEnName === 'meituantuangou'){
                  this.orgPayTypeList[i].money = Number(this.meituantuangou.toFixed(2));
                }
                if (this.orgPayTypeList[i].payEnName === 'douyintuangou'){
                  this.orgPayTypeList[i].money = Number(this.douyintuangou.toFixed(2));
                }
                if (this.orgPayTypeList[i].payEnName === 'koubeituangou'){
                  this.orgPayTypeList[i].money = Number(this.koubeituangou.toFixed(2));
                }
                if (this.orgPayTypeList[i].payEnName === 'xiaochengxutuangou'){
                  this.orgPayTypeList[i].money = Number(this.xiaochengxutuangou.toFixed(2));
                }
              }
            }
          }
        }
      } else {
        let tempMoney3 = Number((this.order.received - this.kuaishoutuangou - this.meituantuangou
          - this.douyintuangou - this.koubeituangou - this.xiaochengxutuangou).toFixed(2));
        this.orgPayTypeList.map((item) =>{
          if (item.payEnName === 'xianjin'){
            if (tempMoney3 < 0){
              item.money = 0;
            } else {
              item.money = tempMoney3;
            }
          }
          if (item.payEnName === 'kuaishoutuangou'){
            item.money = Number(this.kuaishoutuangou.toFixed(2));
          }
          if (item.payEnName === 'meituantuangou'){
            item.money = Number(this.meituantuangou.toFixed(2));
          }
          if (item.payEnName === 'douyintuangou'){
            item.money = Number(this.douyintuangou.toFixed(2));
          }
          if (item.payEnName === 'koubeituangou'){
            item.money = Number(this.koubeituangou.toFixed(2));
          }
          if (item.payEnName === 'xiaochengxutuangou'){
            item.money = Number(this.xiaochengxutuangou.toFixed(2));
          }
        })
      }
    },
    routerOrder(){
      this.$router.push("/orders");
    },
    showCustomerCommentDialog(){
      this.customerComment.comment = '';
      this.customerCommentDialogVisible = true;
    },
    closeCustomerCommentDialog(){
      this.customerCommentDialogVisible = false;
    },
    async createComment(){
      this.customerComment.customerId = this.customerId;
      this.customerComment.orgName = this.orgName;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/customer/create/comment`, this.customerComment)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.closeCustomerCommentDialog();
      await this.loadCustomerComments();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();

    },
    async loadCustomerComments(){
      const {data:res} = await this.$http.get(`/customer/comment/customerId/${this.customerId}/pageNum/${this.currentPage6}/pageSize/${this.pageSize6}`)
      if (res.code === 200){
        this.customerComments = res.data.list;
        this.pageTotal6 = res.data.total;
      }
    },
    handleSizeChange6(val) {
      this.pageSize6 = val;
      this.loadCustomerComments();
    },
    handleCurrentChange6(val) {
      this.currentPage6 = val;
      this.loadCustomerComments();
    },
    handleSizeChange7(val) {
      this.pageSize7 = val;
      this.loadBindRecord();
    },
    handleCurrentChange7(val) {
      this.currentPage7 = val;
      this.loadBindRecord();
    },
    handleSizeChange8(val) {
      this.pageSize8 = val;
      this.oldOrderList();
    },
    handleCurrentChange8(val) {
      this.currentPage8 = val;
      this.oldOrderList();
    },
    async loadBindRecordCount(){
      const {data:res} = await this.$http.get(`/customer/bind/record/count/customerId/${this.customerId}`)

      if (res.code === 200){
        this.pageTotal7 = res.totalPage;
      }
    },
    async loadBindRecord(){
      const {data:res} = await this.$http.get(`/customer/bind/record/customerId/${this.customerId}/pageNum/${this.currentPage7}/pageSize/${this.pageSize7}`)
      if (res.code === 200){
        this.bindCustomerRecord = res.data;
      }
    },
    clearRechargePayType(){
      this.orgPayTypeList.map((item) => {
        item.money = '';
      })
    },
    async showUpdateOrderDialog(data){
      this.clearUpdateOrderDetail();
      this.updateOrderDetail = data;
      this.value1 = data.createTime;
      const {data:res} = await this.$http.get(`/orderDetail/orderId/${data.id}`)
      this.updateOrderDetailList = res.data;
      const {data:res1} = await this.$http.get(`/order/payType/orderId/${data.id}`)
      let orderPayType = res1.data;
      this.clearOrderPayType();
      this.orgPayTypeList.map((item) => {
        orderPayType.map((index) => {
          if (index.payEnName === item.payEnName){
            item.money = index.money - 0;
          }
        })
      })
      const {data:res2} = await this.$http.get(`/orderDetail/server/orderId/${data.id}`)
      this.selectServerList = res2.data;
      if(data.cardId > 0){
        const {data:res3} = await this.$http.get(`/load/one/customerCard/${data.cardId}`)
        this.updateCustomerCard = res3.data;
        this.getCardLevelName(this.updateCustomerCard);
      }

      this.updateOrderDialogVisible = true;
    },
    clearUpdateOrderDetail(){
      this.updateOrderDetail = '';
      this.value1 = '';
      this.storeProduct.customerId='';
      this.tuihuoClick = true;
      this.updateOrderDetailList = [];
      this.orderPayTypeList = [];
      this.selectServerList = [];
      this.updateCustomerCard = '';
    },
    getCardLevelName(customerCard){
      if (customerCard.cardLevel === 0){
        customerCard.cardLevelName = '普通会员';
      }
      if (customerCard.cardLevel === 1){
        customerCard.cardLevelName = '钻石会员';
      }
      if (customerCard.cardLevel === 2){
        customerCard.cardLevelName = '铂金会员';
      }
      if (customerCard.cardLevel === 3){
        customerCard.cardLevelName = '黄金会员';
      }
      if (customerCard.cardLevel === 4){
        customerCard.cardLevelName = '大众会员';
      }
    },
    closeUpdateOrderDialog(){
      this.updateOrderDialogVisible = false;
    },
    async updateOrder(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.updateOrderDetail.orderPayTypeList = this.orgPayTypeList;
      this.updateOrderDetail.servers = this.selectServerList;

      let payAmount = 0;
      this.orgPayTypeList.map((item)=>{
        if(item.payEnName !== 'zengsonghuiyuan'){
          payAmount += item.money - 0;
        }
      })
      if (this.updateOrderDetail.orderReceived !== payAmount){
        this.$message.warning("支付金额与实收金额不一致！请仔细检查支付金额！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      this.updateOrderDetail.orderDate = this.value1;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/order/update`,this.updateOrderDetail);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.closeUpdateOrderDialog();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadCustomer();
    },
    clearOrderPayType(){
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'zengsonghuiyuan'){
          item.money = '';
        }
      })
    },
    async getOldCheckCode(){
      const {data:res} = await this.$http.get(`/users/getCode/${this.oldRefundOrder.phone}`);
      if (res.code === 200){
        return this.$message.success("验证码已发送至您的手机");
      }
    },
    async getCheckCode(){
      const {data:res} = await this.$http.get(`/users/getCode/${this.orderDetail.phone}`);
      if (res.code === 200){
        return this.$message.success("验证码已发送至您的手机");
      }
    },
    showStockProductDialog(){
      this.storeProduct.checkCode = '';
      this.storeProduct.orgId = this.orderDetail.orderOrgId;
      this.storeProduct.orderId = this.orderDetail.id;
      this.storeProduct.customerId = this.orderDetail.customerId;
      this.storeProduct.serverId = this.userId;
      this.storeProduct.phone = this.orderDetail.phone;
      this.stockProductDialogVisible = true;
    },
    closeStockProductDialog(){
      this.stockProductDialogVisible = false;
    },
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      this.nowDate = `${year}-${month}-${day}`
    },
    submitFormatter(row){
      let value = "";
      for (let i = 0; i < this.submitText.length; i++){
        let item = this.submitText[i];
        if (row.isSubmit === item.isSubmit) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async oldOrderCount(){
      this.customerRequest.customerId = this.customer.id;
      const {data:res} = await this.$http.post(`/old/order/count`,this.customerRequest);
      if (res.code === 200){
        this.pageTotal8 = res.totalPage;
      }
    },
    async oldOrderList(){
      this.customerRequest.customerId = this.customer.id;
      this.customerRequest.pageNum = this.currentPage8;
      this.customerRequest.pageSize = this.pageSize8;
      const {data:res} = await this.$http.post(`/old/order/list`,this.customerRequest);
      if (res.code === 200){
        this.oldOrderData = res.data;
      }
    },
    showOldOrderDetailDialog(row){
      this.oldRefundOrder.orgId = ''
      this.oldRefundOrder.orderId = '';
      this.oldRefundOrder.customerId = '';
      this.oldRefundOrder.phone = '';
      this.oldRefundOrder.money = '';
      this.oldRefundOrder.checkCode = '';

      this.oldOrder.id = row.id;
      this.oldOrder.orgId = row.orgId;
      this.oldOrder.customerId = row.customerId;
      this.oldOrder.phone = row.phone;

      // 消费单状态  1退费  0消费
      if (row.orderType == 1){
        this.oldOrderRefundClick = true;
      } else {
        this.oldOrderRefundClick = false;
      }

      this.loadOldOrderDetailData(row.id);
      this.loadOldOrderPayType(row.id);
      this.oldOrderDetailDialogVisible = true;
    },
    closeOldOrderDetailDialog(){
      this.oldOrderDetailDialogVisible = false;
    },
    async loadOldOrderDetailData(orderId){
      const {data:res} = await this.$http.get(`/old/order/detail/${orderId}`);
      this.oldOrderDetailList = res.data;
    },
    async loadOldOrderPayType(orderId){
      const {data:res} = await this.$http.get(`/old/order/pay/type/${orderId}`);
      this.oldOrderPayTypeList = res.data;
    },
    isFundOldOrder(){
      let money = 0;
      this.oldOrderPayTypeList.map((item) =>{
        if (item.payType != 1){
          money += (item.money - 0);
        }
      })
      let message = '';
      if (money > 0){
        message = '退回到现金！'
        this.oldRefundOrder.payType = 2 ;
      } else {
        message = '退回到会员！'
        this.oldRefundOrder.payType = 1;
      }
      this.$confirm(message, '退费提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showRefundOldOrderMoneyDialog();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退费'
        });
      });
    },
    showRefundOldOrderMoneyDialog(){
      this.oldRefundOrder.orgId = this.oldOrder.orgId;
      this.oldRefundOrder.orderId = this.oldOrder.id;
      this.oldRefundOrder.customerId = this.oldOrder.customerId;
      this.oldRefundOrder.phone = this.oldOrder.phone;
      this.oldRefundOrder.money = '';
      this.oldRefundOrder.oldOrderDetailList = this.oldOrderDetailList;
      let yingtui = 0;
      this.oldOrderDetailList.map((item) => {
        if (item.refundNum > 0){
          yingtui += item.discountPrice * Number(item.refundNum);
        }
      })
      this.oldRefundOrder.yingtui = Number(yingtui.toFixed(2));
      this.refundOldOrderMoneyDialogVisible = true;
    },
    closeRefundOldOrderMoneyDialog(){
      this.refundOldOrderMoneyDialogVisible = false;
    },
    async createOldRefundOrder(){
      if (this.oldRefundOrder.yingtui  < this.oldRefundOrder.shitui){
        return this.$message.warning("实退金额 > 应退金额，请核对！");
      }

      if (this.oldRefundOrder.checkCode === '' && this.oldRefundOrder.customerId === ''){
        return this.$message.warning("请输入验证码");
      }

      this.oldRefundOrder.creator = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post('/order/refund/old', this.oldRefundOrder);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      if (res.code === 401){
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return this.$message.error("验证码无效！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      // this.orderDetailList = res.data;
      this.closeRefundOldOrderMoneyDialog();
      this.closeOldOrderDetailDialog();
      await this.loadCustomer();
      await this.loadCustomerOrder();
      await this.loadCustomerTotalPay();
    },
    //计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 295; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    setHyOrderCouZheng(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsHyOrderAmount();
      let hyOrderMoLing = Number(this.order.moLing);
      let giveBalancePay = Number(this.order.giveBalancePay);
      let couZheng = Number(this.order.couZheng);
      this.isMolingSet = true;
      this.order.received = Number((this.order.receivable - this.order.orderDiscounts
        - hyOrderMoLing - giveBalancePay + couZheng).toFixed(2));
      this.selectedCustomerTicket = '';
      this.setPayMoney();
    },
    showHkDialog(row){
      this.arrOrder = row;
      this.arrMoLing = 0;
      this.setArrMoLing();
      this.hkDialogVisible = true;
    },
    closeHkDialog(){
      this.hkDialogVisible = false;
    },
    arrearageMethod(){
      if (this.order.isArrearage){
        this.order.isArr = 1;
      } else {
        this.order.isArr = 2;
        this.order.arrearageMoney = '';
        this.jsHyOrderAmount();
        this.setPayMoney();
      }
    },
    setArrearageMoney(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsHyOrderAmount();
      let money = 0;
      this.consumptionShowList.map((item) => {
        if (item.consumptionTypeName === '抖音团购' || item.consumptionTypeName === '美团团购'
          || item.consumptionTypeName === '口碑团购' || item.consumptionTypeName === '小程序团购'
          || item.consumptionTypeName === '快手团购') {
          money += item.price * item.num;
        }
      })
      if (this.order.arrearageMoney === ''){
        this.order.received = Number((this.order.receivable -  this.order.orderDiscounts - this.order.giveBalancePay
          - this.order.moLing + this.order.couZheng - this.order.arrearageMoney).toFixed(2));
        this.qiankuan = 0;
      } else {
        if (this.order.arrearageMoney > (this.order.received - money)){
          this.$message.warning("欠款金额不能大于" + (this.order.received - money).toFixed(2));
          this.order.arrearageMoney = '';
          return;
        }
        this.qiankuan = parseFloat(this.order.arrearageMoney);
        this.order.received = Number((this.order.receivable -  Number(this.order.orderDiscounts) - this.order.giveBalancePay
          - this.order.moLing + this.order.couZheng - this.order.arrearageMoney).toFixed(2));
      }

      this.setPayMoney();
    },
    loadArrOrder(){
      this.arrOrderRequest.memberId = this.customerId;
      this.arrOrderRequest.pageNum = this.currentPage9;
      this.arrOrderRequest.pageSize = this.pageSize9;
      this.loadArrOrderCount();
      this.loadArrOrderList();
    },
    async loadArrOrderCount(){
      const {data:res} = await this.$http.post(`/card/arr/order/count`, this.arrOrderRequest);
      this.pageTotal9 = res.totalPage;
    },
    async loadArrOrderList(){
      const {data:res} = await this.$http.post(`/card/arr/order/list`, this.arrOrderRequest);
      this.arrOrderList = res.data;
    },
    async hk(){
      this.arrOrder.modifier = this.userId;
      this.arrOrder.moLing = this.arrMoLing;
      this.arrOrder.sjHk = this.sjHk;
      this.arrOrder.orderPayTypeList = this.orgPayTypeList;
      const {data:res} = await this.$http.post(`/arr/order/hk`, this.arrOrder);
      if (res.code === 200){
        this.$message.success("操作成功！");
      } else {
        this.$message.error("操作失败！");
      }
      await this.loadCustomerTotalPay();
      await this.loadCustomer();
      await this.loadArrOrderList();
    },
    setArrMoLing(){
      if (this.arrMoLing === '' || this.arrMoLing === null){
        this.sjHk = this.arrOrder.arrearageMoney;
      } else {
        this.sjHk = this.arrOrder.arrearageMoney - parseFloat(this.arrMoLing).toFixed(2);
      }
      this.resetHyOrderPay();
    },
    arrOrderStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.arrOrderStateText.length; i++){
        let item = this.arrOrderStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    resetHyOrderPay(){
      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (this.sjHk - money)){
            item.money = (this.sjHk - money).toFixed(2);
          }
          money += item.money - 0;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((this.sjHk - money) < 0){
            item.money = 0;
          } else {
            item.money = (this.sjHk - money).toFixed(2);
          }
        }
      })
    },
    showCkDialog(){
      this.customerCiCard.shopCk = '';
      this.selectServerList = [];
      this.clearOrderPayType();
      this.ckDialogVisible = true;
    },
    closeCkDialog(){
      this.ckDialogVisible = false;
    },
    async buyCk(){
      this.customerCiCard.shopId = this.currentOrgId;
      this.customerCiCard.customerId = this.customerId;
      this.customerCiCard.creator = this.userId;
      this.customerCiCard.servers = this.selectServerList;
      this.customerCiCard.ckPayTypeList = this.orgPayTypeList;
      const {data:res} = await this.$http.post(`/customer/buy/ciCard`, this.customerCiCard);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
      this.closeCkDialog();
      await this.loadCustomerTotalPay();
      await this.loadCustomerBuyCkList();
      await this.loadCustomer();

    },
    showShopCkDialog(){
      this.loadShopCk();
      this.shopCkDialogVisible = true;
    },
    closeShopCkDialog(){
      this.shopCkDialogVisible = false;
    },
    loadShopCk(){
      this.baseRequest.shopId = this.currentOrgId;
      this.baseRequest.pageNum = this.shopCkCurrentPage;
      this.baseRequest.pageSize = this.shopCkPageSize
      this.loadShopCkCount();
      this.loadShopCkList();
    },
    async loadShopCkCount(){
      const {data:res} = await this.$http.post(`/shopCk/count`, this.baseRequest);
      this.shopCkPageTotal = res.totalPage;
    },
    async loadShopCkList(){
      const {data:res} = await this.$http.post(`/shopCk/list`, this.baseRequest);
      this.shopCkList = res.data;
    },
    selectShopCk(data){
      this.customerCiCard.shopCk = data;
      this.resetCkPay();
      this.closeShopCkDialog();
    },
    resetCkPay(){
      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (this.customerCiCard.shopCk.money - money)){
            item.money = (this.customerCiCard.shopCk.money - money).toFixed(2);
          }
          money += item.money - 0;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((this.customerCiCard.shopCk.money - money) < 0){
            item.money = 0;
          } else {
            item.money = (this.customerCiCard.shopCk.money - money).toFixed(2);
          }
        }
      })
    },
    showCustomerCardDialog(){
      this.selectedCustomerCard = '';
      this.selectCardIndex = '';
      this.loadCustomerCard();
      this.customerCardDialogVisible = true;
    },
    closeCustomerCardDialog(){
      this.customerCardDialogVisible = false;
    },
    async selectCustomerCard(data){
      this.selectedCustomerCard = data;
      this.returnPremiumCustomerCard = data;
      this.ckCount = data.cardNum;
      if (data.cardLevel === 0){
        this.selectedCustomerCard.cardLevelName = '普通会员';
      }
      if (data.cardLevel === 1){
        this.selectedCustomerCard.cardLevelName = '钻石会员';
      }
      if (data.cardLevel === 2){
        this.selectedCustomerCard.cardLevelName = '铂金会员';
      }
      if (data.cardLevel === 3){
        this.selectedCustomerCard.cardLevelName = '黄金会员';
      }
      if (data.cardLevel === 4){
        this.selectedCustomerCard.cardLevelName = '大众会员';
      }
      await this.loadProductDiscount(data.shopId, data.cardLevel);

      if(data.balance > 0){
        let include = false;
        this.consumptionShowList.map((item, index) =>{
          if (item.consumptionParentTypeName == '团购'){
            include = true;
          }
        })
        if(include){
          this.consumptionShowList = [];
          this.$message.warning("您选择的卡片不能消费团购项目，请重新选择消费项目！");
        }
      } else {
        this.consumptionShowList = [];
      }

      if(this.consumptionShowList.length > 0){
        this.order.moLing = 0;
        this.order.couZheng = 0;
        this.order.arrearageMoney =0;
        this.order.receivable =0;
        this.order.orderDiscounts =0;
        this.order.received =0;
        await this.jsHyOrderAmount();
        await this.setPayMoney();
      }
      this.closeCustomerCardDialog();
    },
    async loadProductDiscount(shopId, cardLevel){
      const {data:res} = await this.$http.get(`/org/discount/${shopId}/${cardLevel}`)
      this.selectedCustomerCard.productDiscount = res.data;
    },
    loadCustomerCard(){
      // this.customerRequest.pageNum = this.cardCurrentPage;
      // this.customerRequest.pageSize = this.cardPageSize;
      this.loadCustomerCardCount();
      this.loadCustomerCardList();
    },
    async loadCustomerCardCount(){
      const {data:res} = await this.$http.get(`/load/customerCard/count/${this.customerId}`)
      this.cardPageTotal = res.totalPage;
    },
    async loadCustomerCardList(){
      const {data:res} = await this.$http.post(`/load/customerCard/list/${this.customerId}`, {
        pageNum: this.cardCurrentPage,
        pageSize: this.cardPageSize
      })
      this.customerCardList = res.data;
      //资金监管区域
      let zjjgqy = [2,5,6,9,12,15,16,17,19,18,510]
      this.customerCardList.map((item) => {
        if(zjjgqy.includes(this.areaId - 0)){
          if(!zjjgqy.includes(item.areaId)){
            item.state = 9;
          }
        } else {
          if (item.areaId == item.shopId){
            if(this.orgLevel == 2){
              if(item.areaId != this.currentOrgId){
                item.state = 9;
              }
            }
            if (this.orgLevel == 3){
              if(item.areaId != this.areaId){
                item.state = 9;
              }
            }
          }
          if (item.areaId != item.shopId){
            if(this.orgLevel == 2){
              if(item.areaId != this.currentOrgId){
                item.state = 9;
              }
            }
            if (this.orgLevel == 3){
              if(item.areaId != this.areaId){
                item.state = 9;
              }
            }
          }
        }
      })
    },
    cardSizeChange(val) {
      this.cardPageSize = val;
      this.loadCustomerCardList();
    },
    cardCurrentChange(val) {
      this.cardCurrentPage = val;
      this.loadCustomerCardList();
    },
    cardLevelFormatter(row){
      let value = "";
      for (let i = 0; i < this.cardText.length; i++){
        let item = this.cardText[i];
        if (row.cardLevel === item.cardLevel) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    cardStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.cardStateText.length; i++){
        let item = this.cardStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    showModifyCustomerCard(row){
      this.modifyCustomerCard = row;
      this.modifyCustomerCardDialogVisible = true;
    },
    closeModifyCustomerCard(){
      this.modifyCustomerCardDialogVisible = false;
    },
    async editCustomerCard(){
      const {data:res} = await this.$http.post(`/edit/customerCard`, this.modifyCustomerCard);
      if(res.code === 200){
        this.$message.success("操作成功！");
      } else {
        this.$message.error("操作失败！");
      }
      this.loadCustomerCard();
      this.closeModifyCustomerCard();
    },
    async showModifyRechargeDialog(data){
      this.clearRechargePayType();
      await this.loadRechargeById(data.id);
      await this.loadRechargePayType(data.id);
      await this.loadRechargeServers(data.id);
      const {data:res} = await this.$http.get(`/load/one/customerCard/${data.cardId}`);
      this.rechargeCustomerCard = res.data;
      this.getCardLevelName(this.rechargeCustomerCard);
      this.xianjin=0;


      this.modifyRechargeDialogVisible = true;
    },
    closeModifyRechargeDialog(){
      this.modifyRechargeDialogVisible = false;
    },
    showCustomerTicketDialog(){
      this.selectTicketIndex = '';
      this.loadCustomerTicket();
      this.customerTicketDialogVisible = true;
    },
    closeCustomerTicketDialog(){
      this.customerTicketDialogVisible = false;
    },
    loadCustomerTicket(){
      this.customerRequest.pageNum = this.ticketCurrentPage;
      this.customerRequest.pageSize = this.ticketPageSize;
      this.loadCustomerTicketCount();
      this.loadCustomerTicketList();
    },
    async loadCustomerKyTicketCount(){
      this.customerRequest.customerId = this.customerId;
      this.customerRequest.shopId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/load/customer/ticket/count`, this.customerRequest)
      this.ticketCount = res.totalPage;
    },
    async loadCustomerTicketCount(){
      const {data:res} = await this.$http.post(`/load/customer/ticket/count`, this.customerRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadCustomerTicketList(){
      const {data:res} = await this.$http.post(`/load/customer/ticket/list`, this.customerRequest)
      this.customerTicketList = res.data;

      this.customerTicketList.map((item) => {
        if (item.state === 1){
          if (item.ticketType < 3){
            item.isUse = 1; //是否可用  1是  2否
          }
          if (item.ticketType === 3){
            if (this.order.received >= item.fullMoney){
              item.isUse = 1; //是否可用  1是  2否
            } else {
              item.isUse = 2;
            }
          }
          if (item.ticketType > 3){
            let result = false;
            this.consumptionShowList.map((consumptionItem) => {
              if (item.consumptionName === consumptionItem.consumptionName){
                result = true;
              }
            })
            if (result){
              item.isUse = 1;
            } else {
              item.isUse = 2;
            }
          }
        } else {
          item.isUse = 2;
        }
      });
    },
    ticketHandleSizeChange(val) {
      this.ticketPageSize = val;
      this.loadCustomerTicketList();
    },
    ticketHandleCurrentChange(val) {
      this.ticketCurrentPage = val;
      this.loadCustomerTicketList();
    },
    selectCustomerTicket(row){
      this.selectedCustomerTicket = row;
      this.closeCustomerTicketDialog();
      this.resetHyOrder();
    },
    resetHyOrder(){
      //初始化一下金额
      this.order.received = Number((this.order.receivable -  Number(this.order.orderDiscounts)
        - this.order.moLing + this.order.couZheng - this.order.arrearageMoney).toFixed(2));
      //全场优惠券
      if (this.selectedCustomerTicket.ticketType === 1){
        this.order.received = Number((this.order.receivable - this.order.orderDiscounts
          - this.order.moLing + this.order.couZheng - this.order.arrearageMoney
          - this.selectedCustomerTicket.money).toFixed(2));
      }
      //全场折扣券
      if (this.selectedCustomerTicket.ticketType === 2){
        this.order.received = (this.order.received * this.selectedCustomerTicket.rate / 10).toFixed(2);
      }
      //全场满减券
      if (this.selectedCustomerTicket.ticketType === 3){
        this.order.received = (this.order.received - this.selectedCustomerTicket.subMoney).toFixed(2);
      }
      //单品优惠券
      if (this.selectedCustomerTicket.ticketType === 4){
        this.order.received = (this.order.received - this.selectedCustomerTicket.money).toFixed(2);
      }
      //单品折扣券
      if (this.selectedCustomerTicket.ticketType === 5){
        let dpHj = 0;
        if (this.selectedCustomerCard.cardLevel > 0){
          this.consumptionShowList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              if (consumptionItem.isShowDia !== 1){
                //表示为服务
                if (consumptionItem.type ===1){
                  if (this.selectedCustomerCard.cardLevel === 1){
                    dpHj += consumptionItem.priceDiamond * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 2){
                    dpHj += consumptionItem.pricePlatinum * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 3){
                    dpHj += consumptionItem.priceGold * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 4){
                    dpHj += consumptionItem.priceBronze * consumptionItem.num;
                  }
                }
                //表示为产品
                if (consumptionItem.type === 2){
                  dpHj += consumptionItem.price * (this.selectedCustomerCard.productDiscount / 100) * consumptionItem.num;
                }
              }
            }
          })
        } else {
          this.consumptionShowList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              if (consumptionItem.isShowDia === 1){   //是否显示直径
                if (consumptionItem.dia !== undefined){
                  dpHj += consumptionItem.price * consumptionItem.num * consumptionItem.dia;
                }
              } else {
                dpHj += consumptionItem.price * consumptionItem.num;
              }
            }
          })
        }
        let subHj = dpHj - (dpHj * this.selectedCustomerTicket.rate / 10);
        this.order.received = (this.order.received - subHj).toFixed(2);
      }
      //单品特价券
      if (this.selectedCustomerTicket.ticketType === 6){
        let dpHj = 0;
        let num = 0;
        if (this.selectedCustomerCard.cardLevel > 0){
          this.consumptionShowList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              num = consumptionItem.num;
              if (consumptionItem.isShowDia !== 1){
                //表示为服务
                if (consumptionItem.type ===1){
                  if (this.selectedCustomerCard.cardLevel === 1){
                    dpHj += consumptionItem.priceDiamond * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 2){
                    dpHj += consumptionItem.pricePlatinum * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 3){
                    dpHj += consumptionItem.priceGold * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 4){
                    dpHj += consumptionItem.priceBronze * consumptionItem.num;
                  }
                }
                //表示为产品
                if (consumptionItem.type === 2){
                  dpHj += consumptionItem.price * (this.selectedCustomerCard.productDiscount / 100) * consumptionItem.num;
                }
              }
            }
          })
        } else {
          this.consumptionShowList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              num = consumptionItem.num;
              dpHj += consumptionItem.price * consumptionItem.num;
            }
          })
        }
        let dpTj = this.selectedCustomerTicket.money * num;
        let subHj = dpHj - dpTj;
        this.order.received = Number((this.order.received - subHj).toFixed(2));
      }
      //单品优惠券
      if (this.selectedCustomerTicket.ticketType === 7){
        let dpHj = 0;
        let dpMoney = 0;
        if (this.selectedCustomerCard.cardLevel > 0){
          this.consumptionShowList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              if (consumptionItem.isShowDia !== 1){
                //表示为服务
                if (consumptionItem.type ===1){
                  if (this.selectedCustomerCard.cardLevel === 1){
                    dpMoney = consumptionItem.priceDiamond;
                    dpHj += consumptionItem.priceDiamond * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 2){
                    dpMoney = consumptionItem.pricePlatinum;
                    dpHj += consumptionItem.pricePlatinum * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 3){
                    dpMoney = consumptionItem.priceGold;
                    dpHj += consumptionItem.priceGold * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 4){
                    dpMoney = consumptionItem.priceBronze;
                    dpHj += consumptionItem.priceBronze * consumptionItem.num;
                  }
                }
                //表示为产品
                if (consumptionItem.type === 2){
                  dpMoney = consumptionItem.price;
                  dpHj += consumptionItem.price * (this.selectedCustomerCard.productDiscount / 100) * consumptionItem.num;
                }
              }
            }
          })
        } else {
          this.consumptionShowList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              dpMoney = consumptionItem.price;
              dpHj += consumptionItem.price * consumptionItem.num;
            }
          })
        }
        this.order.received = Number((this.order.received - dpMoney).toFixed(2));
      }
      this.setPayMoney();
    },
    async loadCustomerBuyCkList(){
      const {data:res} = await this.$http.post('/load/customer/ci/card', {
        customerId: this.customerId,
        pageNum:0,
        pageSize:99999
      });
      this.customerBuyCkList = res.data;
    },
    moreCustomer(){
      this.$router.push({path:'/more/customer', query:{phone: this.customer.phone}});
    },
    getCurrentDate(){
      let today = new Date();
      let year = today.getFullYear();//获取年份
      let month = today.getMonth() + 1;//获取月份
      let day = today.getDate();//获取日期
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + "-" + month + "-" + day;
    }
  },
  mounted() {
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };

  },
  created() {
    this.customerId = this.$route.query.id;
    this.fukaName = this.$route.query.fukaName;
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.orgName = window.sessionStorage.getItem('orgName');
    this.moLingRate = window.sessionStorage.getItem('moLingRate');
    this.loadLockDate();
    this.loadCustomer();
    this.loadCustomerTotalPay();
    this.loadCustomerStoreProduct();
    this.loadOrgPayType();
    this.loadCustomerCard();
    this.loadCustomerBuyCkList();
    this.loadReturnPremiumCount();
    this.loadReturnPremium();
    this.loadCustomerComments();
    this.loadArrOrder();
    this.getNowDate();
    this.getTableHeight();
    this.today = this.getCurrentDate();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}

.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  width: auto;
  margin: 10px 0;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
.spanLabel{
  color: #848484;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}

.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue